(function () {
  'use strict';
  if (window.__owCbV1) return;
  window.__owCbV1 = true;
  var W = window, D = document, HTML = D.documentElement;
  var OW_CUR = {"USD":["$",2,"US dollar"],"EUR":["\u20ac",2,"Euro"],"GBP":["\u00a3",2,"British pound"],"CAD":["CA$",2,"Canadian dollar"],"AUD":["A$",2,"Australian dollar"],"NZD":["NZ$",2,"New Zealand dollar"],"JPY":["\u00a5",0,"Japanese yen"],"CHF":["CHF ",2,"Swiss franc"],"SEK":["SEK ",2,"Swedish krona"],"NOK":["NOK ",2,"Norwegian krone"],"DKK":["DKK ",2,"Danish krone"],"PLN":["PLN ",2,"Polish z\u0142oty"],"CZK":["CZK ",2,"Czech koruna"],"HUF":["HUF ",2,"Hungarian forint"],"RON":["RON ",2,"Romanian leu"],"ISK":["ISK ",0,"Icelandic kr\u00f3na"],"TRY":["\u20ba",2,"Turkish lira"],"ILS":["\u20aa",2,"Israeli shekel"],"INR":["\u20b9",2,"Indian rupee"],"SGD":["S$",2,"Singapore dollar"],"HKD":["HK$",2,"Hong Kong dollar"],"MXN":["MX$",2,"Mexican peso"],"BRL":["R$",2,"Brazilian real"],"ZAR":["ZAR ",2,"South African rand"],"KRW":["\u20a9",0,"South Korean won"],"CNY":["CN\u00a5",2,"Chinese yuan"],"PHP":["\u20b1",2,"Philippine peso"],"THB":["\u0e3f",2,"Thai baht"],"MYR":["RM ",2,"Malaysian ringgit"],"IDR":["IDR ",2,"Indonesian rupiah"],"AED":["AED ",2,"UAE dirham"],"AFN":["AFN ",2,"Afghan afghani"],"ALL":["ALL ",2,"Albanian lek"],"AMD":["AMD ",2,"Armenian dram"],"AOA":["AOA ",2,"Angolan kwanza"],"ARS":["ARS ",2,"Argentine peso"],"AWG":["AWG ",2,"Aruban florin"],"AZN":["AZN ",2,"Azerbaijani manat"],"BAM":["BAM ",2,"Bosnia-Herzegovina convertible mark"],"BBD":["BBD ",2,"Barbadian dollar"],"BDT":["BDT ",2,"Bangladeshi taka"],"BHD":["BHD ",3,"Bahraini dinar"],"BIF":["BIF ",0,"Burundian franc"],"BMD":["BMD ",2,"Bermudian dollar"],"BND":["BND ",2,"Brunei dollar"],"BOB":["BOB ",2,"Bolivian boliviano"],"BSD":["BSD ",2,"Bahamian dollar"],"BTN":["BTN ",2,"Bhutanese ngultrum"],"BWP":["BWP ",2,"Botswana pula"],"BYN":["BYN ",2,"Belarusian ruble"],"BZD":["BZD ",2,"Belize dollar"],"CDF":["CDF ",2,"Congolese franc"],"CLP":["CLP ",0,"Chilean peso"],"COP":["COP ",2,"Colombian peso"],"CRC":["\u20a1",2,"Costa Rican col\u00f3n"],"CVE":["CVE ",2,"Cape Verdean escudo"],"DJF":["DJF ",0,"Djiboutian franc"],"DOP":["DOP ",2,"Dominican peso"],"DZD":["DZD ",2,"Algerian dinar"],"EGP":["EGP ",2,"Egyptian pound"],"ERN":["ERN ",2,"Eritrean nakfa"],"ETB":["ETB ",2,"Ethiopian birr"],"FJD":["FJD ",2,"Fijian dollar"],"FKP":["FKP ",2,"Falkland Islands pound"],"GEL":["GEL ",2,"Georgian lari"],"GHS":["GH\u20b5",2,"Ghanaian cedi"],"GIP":["GIP ",2,"Gibraltar pound"],"GMD":["GMD ",2,"Gambian dalasi"],"GNF":["GNF ",0,"Guinean franc"],"GTQ":["GTQ ",2,"Guatemalan quetzal"],"GYD":["GYD ",2,"Guyanese dollar"],"HNL":["HNL ",2,"Honduran lempira"],"HTG":["HTG ",2,"Haitian gourde"],"IQD":["IQD ",3,"Iraqi dinar"],"JMD":["JMD ",2,"Jamaican dollar"],"JOD":["JOD ",3,"Jordanian dinar"],"KES":["KES ",2,"Kenyan shilling"],"KGS":["KGS ",2,"Kyrgyzstani som"],"KHR":["KHR ",2,"Cambodian riel"],"KMF":["KMF ",0,"Comorian franc"],"KWD":["KWD ",3,"Kuwaiti dinar"],"KYD":["KYD ",2,"Cayman Islands dollar"],"KZT":["\u20b8",2,"Kazakhstani tenge"],"LAK":["\u20ad",2,"Lao kip"],"LKR":["LKR ",2,"Sri Lankan rupee"],"LRD":["LRD ",2,"Liberian dollar"],"LSL":["LSL ",2,"Lesotho loti"],"LYD":["LYD ",3,"Libyan dinar"],"MAD":["MAD ",2,"Moroccan dirham"],"MDL":["MDL ",2,"Moldovan leu"],"MGA":["MGA ",2,"Malagasy ariary"],"MKD":["MKD ",2,"Macedonian denar"],"MMK":["MMK ",2,"Myanmar kyat"],"MNT":["\u20ae",2,"Mongolian t\u00f6gr\u00f6g"],"MOP":["MOP ",2,"Macanese pataca"],"MRU":["MRU ",2,"Mauritanian ouguiya"],"MUR":["MUR ",2,"Mauritian rupee"],"MVR":["MVR ",2,"Maldivian rufiyaa"],"MWK":["MWK ",2,"Malawian kwacha"],"MZN":["MZN ",2,"Mozambican metical"],"NAD":["NAD ",2,"Namibian dollar"],"NGN":["\u20a6",2,"Nigerian naira"],"NIO":["NIO ",2,"Nicaraguan c\u00f3rdoba"],"NPR":["NPR ",2,"Nepalese rupee"],"OMR":["OMR ",3,"Omani rial"],"PAB":["PAB ",2,"Panamanian balboa"],"PEN":["PEN ",2,"Peruvian sol"],"PGK":["PGK ",2,"Papua New Guinean kina"],"PKR":["PKR ",2,"Pakistani rupee"],"PYG":["\u20b2",0,"Paraguayan guaran\u00ed"],"QAR":["QAR ",2,"Qatari riyal"],"RSD":["RSD ",2,"Serbian dinar"],"RUB":["\u20bd",2,"Russian ruble"],"RWF":["RWF ",0,"Rwandan franc"],"SAR":["SAR ",2,"Saudi riyal"],"SBD":["SBD ",2,"Solomon Islands dollar"],"SCR":["SCR ",2,"Seychellois rupee"],"SDG":["SDG ",2,"Sudanese pound"],"SHP":["SHP ",2,"Saint Helena pound"],"SLE":["SLE ",2,"Sierra Leonean leone"],"SOS":["SOS ",2,"Somali shilling"],"SRD":["SRD ",2,"Surinamese dollar"],"SSP":["SSP ",2,"South Sudanese pound"],"STN":["STN ",2,"S\u00e3o Tom\u00e9 and Pr\u00edncipe dobra"],"SZL":["SZL ",2,"Eswatini lilangeni"],"TJS":["TJS ",2,"Tajikistani somoni"],"TMT":["TMT ",2,"Turkmenistani manat"],"TND":["TND ",3,"Tunisian dinar"],"TOP":["TOP ",2,"Tongan pa\u02bbanga"],"TTD":["TTD ",2,"Trinidad and Tobago dollar"],"TWD":["NT$",2,"New Taiwan dollar"],"TZS":["TZS ",2,"Tanzanian shilling"],"UAH":["\u20b4",2,"Ukrainian hryvnia"],"UGX":["UGX ",0,"Ugandan shilling"],"UYU":["UYU ",2,"Uruguayan peso"],"UZS":["UZS ",2,"Uzbekistani som"],"VND":["\u20ab",0,"Vietnamese \u0111\u1ed3ng"],"VUV":["VUV ",0,"Vanuatu vatu"],"WST":["WST ",2,"Samoan t\u0101l\u0101"],"XAF":["XAF ",0,"Central African CFA franc"],"XCD":["EC$",2,"East Caribbean dollar"],"XCG":["XCG ",2,"Caribbean guilder"],"XOF":["XOF ",0,"West African CFA franc"],"XPF":["XPF ",0,"CFP franc"],"YER":["YER ",2,"Yemeni rial"],"ZMW":["ZMW ",2,"Zambian kwacha"]};
/* code given and without decimals (JPY / KRW / ISK / VND ...): rounded ONCE to the whole unit (x 100); with 3 (KWD / BHD ...):
   once to the thousandth (a tenth of a "cent") \u2014 exactly like fx.ts convertCents. */
function owConv(c, rate, code) {
  if (!isFinite(c) || !isFinite(rate) || !(rate > 0)) return NaN;
  var raw = Math.round(c * rate * 1e6) / 1e6;
  var info = code && Object.prototype.hasOwnProperty.call(OW_CUR, code) ? OW_CUR[code] : null;
  if (info && info[1] === 0) { var u = raw / 100; return (u >= 0 ? Math.floor(u + 0.5) : -Math.floor(-u + 0.5)) * 100; }
  if (info && info[1] === 3) { var m = Math.round(raw * 1e7) / 1e6; return (m >= 0 ? Math.floor(m + 0.5) : -Math.floor(-m + 0.5)) / 10; }
  return raw >= 0 ? Math.floor(raw + 0.5) : -Math.floor(-raw + 0.5);
}
function owFormatOk(f) {
  if (f == null || f === '') return true;
  f = String(f).replace(/&#0*36;|&#x0*24;|&dollar;/gi, '$').replace(/<[^>]*>/g, '|');
  return /(^|[^A-Za-z0-9$])\$\s?\{\{\s*amount\s*\}\}/.test(f);
}
function owGroup(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
/* sym: the symbol to print instead of the table's (a Shopify local-currency page: owSafeSym). */
function owFmt(cents, code, sym) {
  if (!isFinite(cents)) return '';
  var info = Object.prototype.hasOwnProperty.call(OW_CUR, code) ? OW_CUR[code] : null, dec = info ? info[1] : 2;
  if (sym == null) sym = info ? info[0] : code + ' ';
  var neg = cents < 0, abs = Math.abs(cents), body;
  if (dec === 0) body = owGroup(String(Math.floor(abs / 100 + 0.5)));
  else if (dec === 3) {
    var mils = Math.round(abs * 10), w3 = Math.floor(mils / 1000), f3 = String(mils - w3 * 1000);
    while (f3.length < 3) f3 = '0' + f3;
    body = owGroup(String(w3)) + '.' + f3;
  } else {
    var whole = Math.floor(abs / 100), frac = String(abs - whole * 100);
    if (frac.length < 2) frac = '0' + frac;
    body = owGroup(String(whole)) + '.' + frac;
  }
  return (neg ? '-' : '') + sym + body;
}
/* "$8.99", "$8.99 USD", "$1,234.5" inside any text; never "CA$" / "A$" / "US$" (a letter before the $). */
var OW_MONEY_RE = /(^|[^A-Za-z0-9$])\$[ \u00a0]?((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)(?:[ \u00a0]?USD\b)?/g;
function owConvertText(t, rate, code) {
  if (!t || t.indexOf('$') === -1 || !(rate > 0)) return null;
  var hit = false;
  var out = t.replace(OW_MONEY_RE, function (m, pre, num) {
    var c = Math.round(parseFloat(num.replace(/,/g, '')) * 100);
    if (!isFinite(c)) return m;
    hit = true;
    return pre + owFmt(owConv(c, rate, code), code);
  });
  return hit ? out : null;
}
/* \u2500\u2500 Shopify local currencies (owner 2026-10-07): the page currency P is what Shopify printed. Its
   amounts are read with a reader built from two probes the snippet prints with the theme's own money
   filters (123456789 | money, | money_with_currency), turned back into store cents with Shopify's own
   rate, then converted like any amount. JavaScript twin of fx.ts pageMoneyFormat / parsePageAmounts /
   formatPageAmount / pageForward / recoverStoreCents / pageSafeSymbol / convertPageText (parity-tested). */
var OW_SP = '[ \\u00a0\\u202f]';
var OW_ENT = { amp: '&', nbsp: '\u00a0', euro: '\u20ac', pound: '\u00a3', yen: '\u00a5', dollar: '$', cent: '\u00a2' };
function owIsSp(c) { return c === ' ' || c === '\u00a0' || c === '\u202f'; }
function owDecode(s) {
  var bad = false;
  var out = String(s).replace(/&(#[0-9]+|#[xX][0-9a-fA-F]+|[A-Za-z][A-Za-z0-9]*);/g, function (m, b) {
    if (b.charAt(0) === '#') {
      var cp = b.charAt(1) === 'x' || b.charAt(1) === 'X' ? parseInt(b.slice(2), 16) : parseInt(b.slice(1), 10);
      if (!(cp > 0 && cp < 0x110000)) { bad = true; return m; }
      if (cp < 0x10000) return String.fromCharCode(cp);
      cp -= 0x10000;
      return String.fromCharCode(0xd800 + (cp >> 10), 0xdc00 + (cp & 0x3ff));
    }
    if (Object.prototype.hasOwnProperty.call(OW_ENT, b)) return OW_ENT[b];
    bad = true;
    return m;
  });
  return bad ? null : out;
}
function owEsc(s) {
  var out = '';
  for (var i = 0; i < s.length; i++) { var ch = s.charAt(i); out += owIsSp(ch) ? OW_SP : ch.replace(/[.*+?^\${}()|[\]\\\/-]/g, '\\$&'); }
  return out;
}
function owShape(probe) {
  if (typeof probe !== 'string' || !probe) return null;
  var segs = probe.split(/<[^>]*>/), seg = null, i;
  for (i = 0; i < segs.length; i++) {
    var dc = owDecode(segs[i]);
    if (dc == null) return null;
    if (/^\s*$/.test(dc)) continue;
    if (seg != null || !/\d/.test(dc)) return null;
    seg = dc;
  }
  if (seg == null) return null;
  var run = /\d[\d.,'\u00a0\u202f ]*\d/.exec(seg);
  if (!run) return null;
  var pre = seg.slice(0, run.index).replace(/^\s+/, ''), suf = seg.slice(run.index + run[0].length).replace(/\s+$/, '');
  if (/\d/.test(pre) || /\d/.test(suf) || (!pre && !suf)) return null;
  var digits = run[0].replace(/\D/g, ''), dec = digits === '123456789' ? 2 : digits === '1234568' ? 0 : -1;
  if (dec === -1) return null;
  var seps = [], cur = '';
  for (i = 1; i < run[0].length; i++) { var ch = run[0].charAt(i); if (/\d/.test(ch)) { seps.push(cur); cur = ''; } else cur += ch; }
  var g = seps[0], d = dec === 2 ? seps[6] : '';
  if (seps[3] !== g || !(g === '' || g === ',' || g === '.' || g === "'" || owIsSp(g))) return null;
  if (dec === 2 && !(d === '.' || d === ',')) return null;
  if (dec === 2 && d === g) return null;
  for (i = 0; i < seps.length; i++) { if (i === 0 || i === 3 || (dec === 2 && i === 6)) continue; if (seps[i] !== '') return null; }
  return { dec: dec, d: d, g: g, pre: pre, suf: suf };
}
function owPart(p, num) {
  var f = p.pre.charAt(0), l = p.suf.charAt(p.suf.length - 1);
  var before = !p.pre ? "(^|[^A-Za-z0-9.,'])" : /[A-Za-z]/.test(f) ? '(^|[^A-Za-z0-9])' : '(^|[^A-Za-z0-9$])';
  var after = !p.suf ? "(?![0-9]|[.,'][0-9])" : /[A-Za-z]/.test(l) ? '(?![A-Za-z])' : '';
  return before + owEsc(p.pre) + '(' + num + ')' + owEsc(p.suf) + after;
}
/* null: the page-currency path is off (an unknown entity, a tag splitting the amount, a bare number, an odd shape, a probe that does not read back). */
function owPageFormat(m, mc) {
  var a = owShape(m), b = owShape(mc);
  if (!a || !b || a.dec !== b.dec || a.d !== b.d || a.g !== b.g) return null;
  var parts = [{ pre: b.pre, suf: b.suf }];
  if (a.pre !== b.pre || a.suf !== b.suf) parts.push({ pre: a.pre, suf: a.suf });
  var g = a.g === '' ? '' : owIsSp(a.g) ? OW_SP : owEsc(a.g);
  var num = '(?:\\d{1,3}(?:' + g + '\\d{3})+|\\d+)' + (a.dec === 2 ? '(?:' + owEsc(a.d) + '\\d{1,2})?' : '');
  var re = [];
  for (var i = 0; i < parts.length; i++) re.push(owPart(parts[i], num));
  var f = { dec: a.dec, d: a.d, g: a.g, parts: parts, re: re.join('|') };
  var want = a.dec === 2 ? 123456789 : 123456800, probes = [m, mc];
  for (var k = 0; k < 2; k++) {
    var segs = String(probes[k]).split(/<[^>]*>/), txt = '';
    for (var j = 0; j < segs.length; j++) txt += owDecode(segs[j]) || '';
    var hits = owPageHits(txt, f);
    if (hits.length !== 1 || hits[0].u !== want) return null;
  }
  return f;
}
function owPageUnits(num, f) {
  var ip = num, fr = '';
  if (f.dec === 2) {
    var at = num.lastIndexOf(f.d);
    if (at !== -1 && num.length - at - 1 <= 2 && /^\d+$/.test(num.slice(at + 1))) { ip = num.slice(0, at); fr = num.slice(at + 1); }
  }
  return Number(ip.replace(/\D/g, '')) * 100 + (fr ? Number((fr + '0').slice(0, 2)) : 0);
}
/* Every page amount in t: { i: start (after the character before it), n: length, u: Shopify money units }. */
function owPageHits(t, f) {
  var out = [];
  if (!t || !f) return out;
  var re = new RegExp(f.re, 'g'), m;
  while ((m = re.exec(t))) {
    for (var k = 0; k < f.parts.length; k++) {
      var pre = m[1 + 2 * k], num = m[2 + 2 * k];
      if (num == null) continue;
      out.push({ i: m.index + pre.length, n: m[0].length - pre.length, u: owPageUnits(num, f) });
      break;
    }
    if (!m[0].length) re.lastIndex++;
  }
  return out;
}
function owGroupWith(s, sep) { return sep ? s.replace(/\B(?=(\d{3})+(?!\d))/g, function () { return sep; }) : s; }
function owPageFmt(units, f) {
  if (!isFinite(units)) return '';
  var p = f.parts[f.parts.length - 1], neg = units < 0, abs = Math.abs(units), body;
  if (f.dec === 0) body = owGroupWith(String(Math.floor(abs / 100 + 0.5)), f.g);
  else { var w = Math.floor(abs / 100), fr = String(abs - w * 100); if (fr.length < 2) fr = '0' + fr; body = owGroupWith(String(w), f.g) + f.d + fr; }
  return (neg ? '-' : '') + p.pre + body + p.suf;
}
function owStep(f) { return f && f.dec === 0 ? 100 : 1; }
/* Shopify's own S -> P conversion (half up, to P's step). */
function owFwd(s, r, g) { var raw = Math.round(s * r * 1e6) / 1e6; return Math.floor(raw / g + 0.5) * g; }
/* The store cents behind a page amount: data-ow-base (hint) when plausible (within PAGE_BASE_MAX_STEPS steps: a
   pack's local price is a sum of per-line conversions); else the one candidate Shopify prints as u; both /
   neither: the nearest cent. */
function owRecover(u, r, g, hint) {
  if (hint != null && isFinite(hint) && hint >= 0 && Math.abs(Math.round(hint * r * 1e6) / 1e6 - u) <= 6 * g) return hint;
  var c = Math.round(u / r * 1e6) / 1e6, lo = Math.floor(c), hi = Math.ceil(c);
  var a = owFwd(lo, r, g) === u, b = hi !== lo && owFwd(hi, r, g) === u;
  if (a && !b) return lo;
  if (b && !a) return hi;
  return Math.floor(c + 0.5);
}
/* A cart LINE of q units: Shopify converts the unit, then multiplies \u2014 q x the unit's store cents (fx.ts recoverLineStoreCents). */
function owRecoverLine(u, q, r, g) {
  if (!(q > 1) || u % (q * g) !== 0) return owRecover(u, r, g);
  return q * owRecover(u / q, r, g);
}
/* Which amounts of t are read (fx.ts pickPageAmounts): 'all'; 'option' = only a node that is just one amount;
   'discount' = that, or Dawn's trailing "(-amount)" \u2014 never an amount in the owner's own title. */
function owPickHits(t, f, kind) {
  var hits = owPageHits(t, f);
  if (kind === 'all' || !hits.length) return hits;
  var last = hits[hits.length - 1], before = t.slice(0, last.i), after = t.slice(last.i + last.n);
  if (/^\s*$/.test(after) && /^\s*[-\u2212]?\s*$/.test(before)) return [last];
  if (kind === 'discount' && /^\s*\)\s*$/.test(after) && /\(\s*[-\u2212]?\s*$/.test(before)) return [last];
  return [];
}
/* A marked store-currency amount inside other words ("Add 4 \u2013 $15.99"): only the amount (data-ow-amt, found by the
   store reader exactly once; else the one "$" amount) is replaced, and it must read as the marked cents (fx.ts spliceStoreAmount). */
function owStoreSplice(t, amt, cents, rep) {
  var re = new RegExp(OW_MONEY_RE.source, 'g'), m, at = -1, len = 0, v = NaN, n = 0;
  while ((m = re.exec(t))) {
    var piece = m[0].slice(m[1].length);
    if (amt && !(piece === amt || (piece.indexOf(amt) === 0 && /^[ \u00a0]?USD$/.test(piece.slice(amt.length))))) continue;
    n++;
    at = m.index + m[1].length; len = piece.length; v = Math.round(parseFloat(m[2].replace(/,/g, '')) * 100);
  }
  /* The box's store-currency fallback writes "US$16.20" (kbFxStoreText): that exact text, once, as its own word. */
  var mu = n === 0 && amt ? /^US\$((?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d{1,2})?)$/.exec(amt) : null, k = mu ? t.indexOf(amt) : -1;
  if (k !== -1 && t.indexOf(amt, k + 1) === -1 && !/[A-Za-z0-9$]/.test(t.charAt(k - 1))) { n = 1; at = k; len = amt.length; v = Math.round(parseFloat(mu[1].replace(/,/g, '')) * 100); }
  if (n !== 1 || v !== Math.abs(cents)) return null;
  return t.slice(0, at) + rep + t.slice(at + len);
}
function owRate(v) {
  var s = typeof v === 'number' ? String(v) : typeof v === 'string' ? v : '';
  if (!/^\d+(\.\d+)?$/.test(s)) return 0;
  var n = Number(s);
  return isFinite(n) && n > 0 ? n : 0;
}
function owRateSane(r, fx) { return r > 0 && (!(fx > 0) || Math.abs(r / fx - 1) <= 0.2); }
/* The table symbol, else "US$", else the ISO code: the first the page's reader cannot read (never converted twice). */
function owSafeSym(code, f) {
  var info = Object.prototype.hasOwnProperty.call(OW_CUR, code) ? OW_CUR[code] : null;
  var c = [info ? info[0] : code + ' '];
  if (code === 'USD') c.push('US$');
  c.push(code + ' ');
  var smp = ['8.99', '1,234.56', '1,349', '12'];
  for (var i = 0; i < c.length; i++) {
    var hit = false;
    for (var j = 0; j < smp.length && !hit; j++) if (owPageHits(c[i] + smp[j], f).length) hit = true;
    if (!hit) return c[i];
  }
  return code + ' ';
}
/* x: { f, r, g, base, rates, sym (cache, optional) }. */
function owStoreIn(s, code, x) {
  var sym = x.sym ? x.sym[code] : null;
  if (sym == null) { sym = owSafeSym(code, x.f); if (x.sym) x.sym[code] = sym; }
  return code === x.base ? owFmt(s, code, sym) : owFmt(owConv(s, x.rates[code], code), code, sym);
}
function owPageAmt(u, code, x, hint) { return owStoreIn(owRecover(u, x.r, x.g, hint), code, x); }
function owPageText(t, code, x) {
  var hits = owPageHits(t, x.f);
  if (!hits.length) return null;
  var out = '', at = 0;
  for (var i = 0; i < hits.length; i++) { out += t.slice(at, hits[i].i) + owPageAmt(hits[i].u, code, x); at = hits[i].i + hits[i].n; }
  return out + t.slice(at);
}

  function owTarget(st) {
  var P = st.P, own = st.own, owner = st.owner, cs = st.cs || [], mk = st.mark;
  var def = st.multi ? (own && cs.indexOf(own) < 0 ? own : null) : own;
  var list = owner.slice(), top = !!own && owner.indexOf(own) < 0;
  if (top) list.unshift(own);
  if (P !== st.S && list.indexOf(P) < 0) list.splice(top ? 1 : 0, 0, P);
  var v = st.raw, pick = null, drop = false, stamp = false;
  if (v) {
    var marked = v.slice(0, mk.length) === mk;
    pick = marked ? v.slice(mk.length) : v;
    if (!marked && top) pick = null;
    if (!pick || list.indexOf(pick) < 0) pick = null;
  }
  if (st.multi && st.pp && st.pp !== P) { pick = null; drop = true; }
  else if (st.multi && pick && !st.pp) stamp = true;
  return { t: drop ? P : pick || def || P, list: list, pick: pick, own: def, drop: drop, stamp: stamp };
}
  var PRICE_SCOPE = ".money,.price,.totals__total-value,.cart-item__price-wrapper,.cart-item__totals,.cart-item__details .product-option,.cart-item__discounted-prices,.discounts__discount,.price-per-item,#kbBox,[id^=\"ProductSubmitButton\"]>span,[data-ow-money],.price-item,.unit-price,.totals__subtotal-value";
  var FLAG_SVG = {"USD":"20 14|<rect width=\"20\" height=\"14\" fill=\"#fff\"/><path d=\"M0 0h20v1.08H0zM0 2.15h20v1.08H0zM0 4.31h20v1.08H0zM0 6.46h20v1.08H0zM0 8.62h20v1.08H0zM0 10.77h20v1.08H0zM0 12.92h20V14H0z\" fill=\"#b22234\"/><rect width=\"8\" height=\"7.54\" fill=\"#3c3b6e\"/>","GBP":"60 30|<rect width=\"60\" height=\"30\" fill=\"#012169\"/><path d=\"M0,0 60,30M60,0 0,30\" stroke=\"#fff\" stroke-width=\"6\"/><path d=\"M0,0 60,30M60,0 0,30\" stroke=\"#c8102e\" stroke-width=\"2\"/><path d=\"M30,0v30M0,15h60\" stroke=\"#fff\" stroke-width=\"10\"/><path d=\"M30,0v30M0,15h60\" stroke=\"#c8102e\" stroke-width=\"6\"/>","CAD":"40 20|<rect width=\"40\" height=\"20\" fill=\"#fff\"/><rect width=\"10\" height=\"20\" fill=\"#d52b1e\"/><rect x=\"30\" width=\"10\" height=\"20\" fill=\"#d52b1e\"/><path d=\"M20 4l1.2 2.4 1.6-.6-.6 3.4 2-1.6.4 1.2 2-.4-.8 2 .8.4-3.4 2.6.4 1.2-3.4-.4V17h-.6v-2.8l-3.4.4.4-1.2-3.4-2.6.8-.4-.8-2 2 .4.4-1.2 2 1.6-.6-3.4 1.6.6z\" fill=\"#d52b1e\"/>","AUD":"40 20|<rect width=\"40\" height=\"20\" fill=\"#012169\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#fff\" stroke-width=\"2\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#c8102e\" stroke-width=\".8\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#fff\" stroke-width=\"3\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#c8102e\" stroke-width=\"1.8\"/><g fill=\"#fff\"><circle cx=\"10\" cy=\"15\" r=\"1.8\"/><circle cx=\"30\" cy=\"4\" r=\".9\"/><circle cx=\"26\" cy=\"9\" r=\".9\"/><circle cx=\"33\" cy=\"8\" r=\".9\"/><circle cx=\"30\" cy=\"16\" r=\".9\"/><circle cx=\"31.5\" cy=\"11\" r=\".5\"/></g>","EUR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#039\"/><g fill=\"#fc0\"><circle cx=\"15\" cy=\"4\" r=\".9\"/><circle cx=\"18\" cy=\"4.8\" r=\".9\"/><circle cx=\"20.2\" cy=\"7\" r=\".9\"/><circle cx=\"21\" cy=\"10\" r=\".9\"/><circle cx=\"20.2\" cy=\"13\" r=\".9\"/><circle cx=\"18\" cy=\"15.2\" r=\".9\"/><circle cx=\"15\" cy=\"16\" r=\".9\"/><circle cx=\"12\" cy=\"15.2\" r=\".9\"/><circle cx=\"9.8\" cy=\"13\" r=\".9\"/><circle cx=\"9\" cy=\"10\" r=\".9\"/><circle cx=\"9.8\" cy=\"7\" r=\".9\"/><circle cx=\"12\" cy=\"4.8\" r=\".9\"/></g>","THB":"30 20|<rect width=\"30\" height=\"20\" fill=\"#a51931\"/><rect y=\"3.33\" width=\"30\" height=\"16.67\" fill=\"#f4f5f8\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#2d2a4a\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#f4f5f8\"/><rect y=\"16.67\" width=\"30\" height=\"3.33\" fill=\"#a51931\"/>","NZD":"40 20|<rect width=\"40\" height=\"20\" fill=\"#012169\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#fff\" stroke-width=\"2\"/><path d=\"M0,0 20,10M20,0 0,10\" stroke=\"#c8102e\" stroke-width=\".8\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#fff\" stroke-width=\"3\"/><path d=\"M10,0v10M0,5h20\" stroke=\"#c8102e\" stroke-width=\"1.8\"/><g fill=\"#c8102e\" stroke=\"#fff\" stroke-width=\".4\"><circle cx=\"30\" cy=\"4\" r=\"1\"/><circle cx=\"26\" cy=\"9\" r=\"1\"/><circle cx=\"33.5\" cy=\"8\" r=\"1\"/><circle cx=\"30\" cy=\"16\" r=\"1\"/></g>","JPY":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><circle cx=\"15\" cy=\"10\" r=\"6\" fill=\"#bc002d\"/>","CHF":"20 20|<rect width=\"20\" height=\"20\" fill=\"#da291c\"/><path d=\"M8 4h4v4h4v4h-4v4H8v-4H4V8h4z\" fill=\"#fff\"/>","SEK":"16 10|<rect width=\"16\" height=\"10\" fill=\"#006aa7\"/><path d=\"M5 0h2v10H5zM0 4h16v2H0z\" fill=\"#fecc00\"/>","NOK":"22 16|<rect width=\"22\" height=\"16\" fill=\"#ba0c2f\"/><path d=\"M6 0h4v16H6zM0 6h22v4H0z\" fill=\"#fff\"/><path d=\"M7 0h2v16H7zM0 7h22v2H0z\" fill=\"#00205b\"/>","DKK":"37 28|<rect width=\"37\" height=\"28\" fill=\"#c8102e\"/><path d=\"M12 0h4v28h-4zM0 12h37v4H0z\" fill=\"#fff\"/>","ISK":"25 18|<rect width=\"25\" height=\"18\" fill=\"#02529c\"/><path d=\"M7 0h4v18H7zM0 7h25v4H0z\" fill=\"#fff\"/><path d=\"M8 0h2v18H8zM0 8h25v2H0z\" fill=\"#dc1e35\"/>","PLN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#dc143c\"/>","CZK":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#d7141a\"/><path d=\"M0 0l15 10L0 20z\" fill=\"#11457e\"/>","HUF":"30 20|<rect width=\"30\" height=\"20\" fill=\"#cd2a3e\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#436f4d\"/>","RON":"30 20|<rect width=\"30\" height=\"20\" fill=\"#002b7f\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fcd116\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#ce1126\"/>","TRY":"30 20|<rect width=\"30\" height=\"20\" fill=\"#e30a17\"/><circle cx=\"10.5\" cy=\"10\" r=\"5\" fill=\"#fff\"/><circle cx=\"11.8\" cy=\"10\" r=\"4\" fill=\"#e30a17\"/><polygon points=\"19.5,10 17.9,10.5 17.9,12.2 16.9,10.8 15.3,11.4 16.3,10 15.3,8.6 16.9,9.2 17.9,7.8 17.9,9.5\" fill=\"#fff\"/>","ILS":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><path d=\"M0 2h30v3H0zM0 15h30v3H0z\" fill=\"#0038b8\"/><path d=\"M15 6.3l3.2 5.5h-6.4zM15 13.7l-3.2-5.5h6.4z\" fill=\"none\" stroke=\"#0038b8\" stroke-width=\".9\"/>","INR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#f93\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#138808\"/><circle cx=\"15\" cy=\"10\" r=\"2.4\" fill=\"none\" stroke=\"#000080\" stroke-width=\".7\"/>","SGD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ef3340\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#fff\"/><circle cx=\"6\" cy=\"5\" r=\"3.3\" fill=\"#fff\"/><circle cx=\"7.3\" cy=\"5\" r=\"3.2\" fill=\"#ef3340\"/><g fill=\"#fff\"><circle cx=\"9.6\" cy=\"3.2\" r=\".6\"/><circle cx=\"11.4\" cy=\"4.5\" r=\".6\"/><circle cx=\"10.7\" cy=\"6.6\" r=\".6\"/><circle cx=\"8.5\" cy=\"6.6\" r=\".6\"/><circle cx=\"7.8\" cy=\"4.5\" r=\".6\"/></g>","HKD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#de2910\"/><circle cx=\"15\" cy=\"7.4\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"17.47\" cy=\"9.2\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"16.53\" cy=\"12.1\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"13.47\" cy=\"12.1\" r=\"2.1\" fill=\"#fff\"/><circle cx=\"12.53\" cy=\"9.2\" r=\"2.1\" fill=\"#fff\"/>","MXN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#006847\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fff\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#ce1126\"/><circle cx=\"15\" cy=\"10\" r=\"2.2\" fill=\"#8c6a2c\"/>","BRL":"30 20|<rect width=\"30\" height=\"20\" fill=\"#009b3a\"/><path d=\"M15 2.5L27.5 10 15 17.5 2.5 10z\" fill=\"#fedf00\"/><circle cx=\"15\" cy=\"10\" r=\"4.2\" fill=\"#002776\"/>","ZAR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#001489\"/><rect width=\"30\" height=\"10\" fill=\"#e03c31\"/><path d=\"M0 0l12 10L0 20\" fill=\"none\" stroke=\"#fff\" stroke-width=\"7\"/><rect x=\"11\" y=\"6.5\" width=\"19\" height=\"7\" fill=\"#fff\"/><path d=\"M0 0l12 10L0 20\" fill=\"none\" stroke=\"#007749\" stroke-width=\"4\"/><rect x=\"11\" y=\"8\" width=\"19\" height=\"4\" fill=\"#007749\"/><path d=\"M0 3.2L8.2 10 0 16.8z\" fill=\"#ffb612\"/><path d=\"M0 4.8L6.3 10 0 15.2z\" fill=\"#000\"/>","KRW":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><circle cx=\"15\" cy=\"10\" r=\"5\" fill=\"#0047a0\"/><path d=\"M10 10a5 5 0 0 1 10 0z\" fill=\"#cd2e3a\"/><g fill=\"#000\"><rect x=\"3.5\" y=\"3.4\" width=\"5\" height=\"2.4\" transform=\"rotate(34 6 4.6)\"/><rect x=\"21.5\" y=\"3.4\" width=\"5\" height=\"2.4\" transform=\"rotate(-34 24 4.6)\"/><rect x=\"3.5\" y=\"14.2\" width=\"5\" height=\"2.4\" transform=\"rotate(-34 6 15.4)\"/><rect x=\"21.5\" y=\"14.2\" width=\"5\" height=\"2.4\" transform=\"rotate(34 24 15.4)\"/></g>","CNY":"30 20|<rect width=\"30\" height=\"20\" fill=\"#de2910\"/><polygon points=\"5,2 5.7,4.1 7.9,4.1 6.1,5.4 6.8,7.4 5,6.1 3.2,7.4 3.9,5.4 2.1,4.1 4.3,4.1\" fill=\"#ffde00\"/><g fill=\"#ffde00\"><circle cx=\"10\" cy=\"2\" r=\".8\"/><circle cx=\"12\" cy=\"4\" r=\".8\"/><circle cx=\"12\" cy=\"7\" r=\".8\"/><circle cx=\"10\" cy=\"9\" r=\".8\"/></g>","PHP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#0038a8\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#ce1126\"/><path d=\"M0 0l17.3 10L0 20z\" fill=\"#fff\"/><circle cx=\"5.8\" cy=\"10\" r=\"1.9\" fill=\"#fcd116\"/>","MYR":"28 14|<rect width=\"28\" height=\"14\" fill=\"#fff\"/><path d=\"M0 0h28v1H0zM0 2h28v1H0zM0 4h28v1H0zM0 6h28v1H0zM0 8h28v1H0zM0 10h28v1H0zM0 12h28v1H0z\" fill=\"#cc0001\"/><rect width=\"14\" height=\"8\" fill=\"#010066\"/><circle cx=\"5.5\" cy=\"4\" r=\"2.8\" fill=\"#fc0\"/><circle cx=\"6.5\" cy=\"4\" r=\"2.4\" fill=\"#010066\"/><polygon points=\"10,2.4 10.4,3.5 11.5,3.5 10.6,4.2 10.9,5.3 10,4.6 9.1,5.3 9.4,4.2 8.5,3.5 9.6,3.5\" fill=\"#fc0\"/>","IDR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ce1126\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#fff\"/>","VND":"30 20|<rect width=\"30\" height=\"20\" fill=\"#da251d\"/><polygon points=\"15,4.8 16.3,8.7 20.3,8.7 17,11.1 18.3,14.9 15,12.5 11.7,14.9 13,11.1 9.7,8.7 13.7,8.7\" fill=\"#ff0\"/>","TWD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fe0000\"/><rect width=\"15\" height=\"10\" fill=\"#000095\"/><circle cx=\"7.5\" cy=\"5\" r=\"2.7\" fill=\"#fff\"/>","AED":"30 20|<rect width=\"30\" height=\"20\" fill=\"#00732f\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#000\"/><rect width=\"7.5\" height=\"20\" fill=\"#f00\"/>","SAR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#006c35\"/><rect x=\"7\" y=\"6\" width=\"16\" height=\"3\" rx=\"1\" fill=\"#fff\"/><rect x=\"7\" y=\"12.5\" width=\"16\" height=\"1\" fill=\"#fff\"/>","NGN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#008751\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fff\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#008751\"/>","KES":"30 20|<rect width=\"30\" height=\"20\" fill=\"#000\"/><rect y=\"6\" width=\"30\" height=\"14\" fill=\"#fff\"/><rect y=\"7\" width=\"30\" height=\"6\" fill=\"#b00\"/><rect y=\"14\" width=\"30\" height=\"6\" fill=\"#060\"/><ellipse cx=\"15\" cy=\"10\" rx=\"2.6\" ry=\"6\" fill=\"#b00\" stroke=\"#000\" stroke-width=\".6\"/>","PKR":"30 20|<rect width=\"30\" height=\"20\" fill=\"#01411c\"/><rect width=\"7.5\" height=\"20\" fill=\"#fff\"/><circle cx=\"19\" cy=\"10\" r=\"5\" fill=\"#fff\"/><circle cx=\"20.4\" cy=\"8.9\" r=\"4.3\" fill=\"#01411c\"/><polygon points=\"23.3,5.8 23.1,6.8 24,7.3 23,7.4 22.7,8.4 22.3,7.5 21.3,7.6 22.1,6.9 21.7,6 22.5,6.5\" fill=\"#fff\"/>","EGP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ce1126\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#000\"/><circle cx=\"15\" cy=\"10\" r=\"1.8\" fill=\"#c09300\"/>","UAH":"30 20|<rect width=\"30\" height=\"20\" fill=\"#0057b7\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#ffd700\"/>","COP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fcd116\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#003893\"/><rect y=\"15\" width=\"30\" height=\"5\" fill=\"#ce1126\"/>","CLP":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"10\" width=\"30\" height=\"10\" fill=\"#d52b1e\"/><rect width=\"10\" height=\"10\" fill=\"#0039a6\"/><polygon points=\"5,2.6 5.5,4.3 7.3,4.3 5.9,5.3 6.4,6.9 5,5.9 3.6,6.9 4.1,5.3 2.7,4.3 4.5,4.3\" fill=\"#fff\"/>","PEN":"30 20|<rect width=\"30\" height=\"20\" fill=\"#d91023\"/><rect x=\"10\" width=\"20\" height=\"20\" fill=\"#fff\"/><rect x=\"20\" width=\"10\" height=\"20\" fill=\"#d91023\"/>","ARS":"30 20|<rect width=\"30\" height=\"20\" fill=\"#74acdf\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fff\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#74acdf\"/><circle cx=\"15\" cy=\"10\" r=\"1.8\" fill=\"#f6b40e\"/>","RUB":"30 20|<rect width=\"30\" height=\"20\" fill=\"#fff\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#0039a6\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#d52b1e\"/>","BDT":"30 20|<rect width=\"30\" height=\"20\" fill=\"#006a4e\"/><circle cx=\"13.5\" cy=\"10\" r=\"5.5\" fill=\"#f42a41\"/>","MAD":"30 20|<rect width=\"30\" height=\"20\" fill=\"#c1272d\"/><path d=\"M15 5.6l2.6 8-6.8-4.9h8.4l-6.8 4.9z\" fill=\"none\" stroke=\"#006233\" stroke-width=\".8\"/>","GHS":"30 20|<rect width=\"30\" height=\"20\" fill=\"#ce1126\"/><rect y=\"6.67\" width=\"30\" height=\"13.33\" fill=\"#fcd116\"/><rect y=\"13.33\" width=\"30\" height=\"6.67\" fill=\"#006b3f\"/><polygon points=\"15,7.3 15.7,9.4 17.9,9.4 16.1,10.7 16.8,12.7 15,11.4 13.2,12.7 13.9,10.7 12.1,9.4 14.3,9.4\" fill=\"#000\"/>"};
  var FLAG_CC = {"USD":"US","EUR":"EU","GBP":"GB","CAD":"CA","AUD":"AU","NZD":"NZ","JPY":"JP","CHF":"CH","SEK":"SE","NOK":"NO","DKK":"DK","PLN":"PL","CZK":"CZ","HUF":"HU","RON":"RO","ISK":"IS","TRY":"TR","ILS":"IL","INR":"IN","SGD":"SG","HKD":"HK","MXN":"MX","BRL":"BR","ZAR":"ZA","KRW":"KR","CNY":"CN","PHP":"PH","THB":"TH","MYR":"MY","IDR":"ID","AED":"AE","AFN":"AF","ALL":"AL","AMD":"AM","AOA":"AO","ARS":"AR","AWG":"AW","AZN":"AZ","BAM":"BA","BBD":"BB","BDT":"BD","BHD":"BH","BIF":"BI","BMD":"BM","BND":"BN","BOB":"BO","BSD":"BS","BTN":"BT","BWP":"BW","BYN":"BY","BZD":"BZ","CDF":"CD","CLP":"CL","COP":"CO","CRC":"CR","CVE":"CV","DJF":"DJ","DOP":"DO","DZD":"DZ","EGP":"EG","ERN":"ER","ETB":"ET","FJD":"FJ","FKP":"FK","GEL":"GE","GHS":"GH","GIP":"GI","GMD":"GM","GNF":"GN","GTQ":"GT","GYD":"GY","HNL":"HN","HTG":"HT","IQD":"IQ","JMD":"JM","JOD":"JO","KES":"KE","KGS":"KG","KHR":"KH","KMF":"KM","KWD":"KW","KYD":"KY","KZT":"KZ","LAK":"LA","LKR":"LK","LRD":"LR","LSL":"LS","LYD":"LY","MAD":"MA","MDL":"MD","MGA":"MG","MKD":"MK","MMK":"MM","MNT":"MN","MOP":"MO","MRU":"MR","MUR":"MU","MVR":"MV","MWK":"MW","MZN":"MZ","NAD":"NA","NGN":"NG","NIO":"NI","NPR":"NP","OMR":"OM","PAB":"PA","PEN":"PE","PGK":"PG","PKR":"PK","PYG":"PY","QAR":"QA","RSD":"RS","RUB":"RU","RWF":"RW","SAR":"SA","SBD":"SB","SCR":"SC","SDG":"SD","SHP":"SH","SLE":"SL","SOS":"SO","SRD":"SR","SSP":"SS","STN":"ST","SZL":"SZ","TJS":"TJ","TMT":"TM","TND":"TN","TOP":"TO","TTD":"TT","TWD":"TW","TZS":"TZ","UAH":"UA","UGX":"UG","UYU":"UY","UZS":"UZ","VND":"VN","VUV":"VU","WST":"WS","XAF":"\ud83c\udf0d","XCD":"\ud83c\udf0e","XCG":"CW","XOF":"\ud83c\udf0d","XPF":"\ud83c\udf0f","YER":"YE","ZMW":"ZM"};
  var OW_COUNTRIES = {"SHP":"ACSH","EUR":"ADATAXBEBGBLCYDEEEESFIFRGFGPGRHRIEITLTLULVMCMEMFMQMTNLPMPTRESISKSMTFVAXKYT","AED":"AE","AFN":"AF","XCD":"AGAIDMGDKNLCMSVC","ALL":"AL","AMD":"AM","AOA":"AO","USD":"AQASBQCUECFMGUIOIRKPLBMHMPPAPRPWSVSYTCTLUMUSVEVGVIZW","ARS":"AR","AUD":"AUCCCXHMKINFNRTV","AWG":"AW","AZN":"AZ","BAM":"BA","BBD":"BB","BDT":"BD","XOF":"BFBJCIGWMLNESNTG","BHD":"BH","BIF":"BI","BMD":"BM","BND":"BN","BOB":"BO","BRL":"BR","BSD":"BS","BTN":"BT","NOK":"BVNOSJ","BWP":"BW","BYN":"BY","BZD":"BZ","CAD":"CA","CDF":"CD","XAF":"CFCGCMGAGQTD","CHF":"CHLI","NZD":"CKNUNZPNTK","CLP":"CL","CNY":"CN","COP":"CO","CRC":"CR","CVE":"CV","XCG":"CWSX","CZK":"CZ","DJF":"DJ","DKK":"DKFOGL","DOP":"DO","DZD":"DZ","EGP":"EG","MAD":"EHMA","ERN":"ER","ETB":"ET","FJD":"FJ","FKP":"FK","GBP":"GBGGGSIMJETA","GEL":"GE","GHS":"GH","GIP":"GI","GMD":"GM","GNF":"GN","GTQ":"GT","GYD":"GY","HKD":"HK","HNL":"HN","HTG":"HT","HUF":"HU","IDR":"ID","ILS":"ILPS","INR":"IN","IQD":"IQ","ISK":"IS","JMD":"JM","JOD":"JO","JPY":"JP","KES":"KE","KGS":"KG","KHR":"KH","KMF":"KM","KRW":"KR","KWD":"KW","KYD":"KY","KZT":"KZ","LAK":"LA","LKR":"LK","LRD":"LR","LSL":"LS","LYD":"LY","MDL":"MD","MGA":"MG","MKD":"MK","MMK":"MM","MNT":"MN","MOP":"MO","MRU":"MR","MUR":"MU","MVR":"MV","MWK":"MW","MXN":"MX","MYR":"MY","MZN":"MZ","NAD":"NA","XPF":"NCPFWF","NGN":"NG","NIO":"NI","NPR":"NP","OMR":"OM","PEN":"PE","PGK":"PG","PHP":"PH","PKR":"PK","PLN":"PL","PYG":"PY","QAR":"QA","RON":"RO","RSD":"RS","RUB":"RU","RWF":"RW","SAR":"SA","SBD":"SB","SCR":"SC","SDG":"SD","SEK":"SE","SGD":"SG","SLE":"SL","SOS":"SO","SRD":"SR","SSP":"SS","STN":"ST","SZL":"SZ","THB":"TH","TJS":"TJ","TMT":"TM","TND":"TN","TOP":"TO","TRY":"TR","TTD":"TT","TWD":"TW","TZS":"TZ","UAH":"UA","UGX":"UG","UYU":"UY","UZS":"UZ","VND":"VN","VUV":"VU","WST":"WS","YER":"YE","ZAR":"ZA","ZMW":"ZM"};
  function own(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  function noop() {}
  function warn(name, e) { try { console.warn('[OpenWeav Booster] ' + name + ' stopped:', e && e.message ? e.message : e); } catch (x) {} }
  function safe(name, fn) { try { fn(); } catch (e) { warn(name, e); } }
  function unhold() {
    try { HTML.className = HTML.className.replace(/(^|\s)ow-cb-hold(?=\s|$)/g, ''); } catch (e) {}
  }
  function lsGet(k) { try { return W.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { W.localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { W.localStorage.removeItem(k); } catch (e) {} }
  function raf(fn) { (W.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(fn); }
  function addClass(el, c) { if ((' ' + el.className + ' ').indexOf(' ' + c + ' ') === -1) el.className = (el.className ? el.className + ' ' : '') + c; }
  function removeClass(el, c) { el.className = (' ' + el.className + ' ').replace(' ' + c + ' ', ' ').replace(/^\s+|\s+$/g, ''); }
  function textNode(el, value) {
    /* One text node per element we own: later updates change nodeValue only (no removed nodes). */
    var t = D.createTextNode(value == null ? '' : String(value));
    el.appendChild(t);
    return t;
  }
  function setText(t, value) { value = value == null ? '' : String(value); if (t.nodeValue !== value) t.nodeValue = value; }
  function cleanText(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''); }

  var cfg = null;
  try {
    var cfgEl = D.getElementById('ow-booster-config');
    cfg = cfgEl ? JSON.parse(cfgEl.textContent || 'null') : null;
  } catch (e) { cfg = null; }
  if (!cfg || !cfg.c || cfg.c.v !== 1) { unhold(); return; }
  var C = cfg.c, FX = cfg.fx || null, SHOP = cfg.shop || {}, PAGE = cfg.page || {};
  var BASE = String(SHOP.currency || 'USD').toUpperCase();
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || SHOP.root || '/';
  var PRODUCT = PAGE.t === 'product' && PAGE.p ? PAGE.p : null;
  /* How this page prints money (Shopify local currencies, 2026-10-07): a SEPARATE element, so a
     Liquid error in it only switches the page-currency path off \u2014 never the whole booster. */
  var MONEY = null, PAGE_FMT = null;
  try {
    var moneyEl = D.getElementById('ow-booster-money');
    MONEY = moneyEl ? JSON.parse(moneyEl.textContent || 'null') : null;
    if (!MONEY || typeof MONEY !== 'object') MONEY = null;
    PAGE_FMT = MONEY ? owPageFormat(MONEY.m, MONEY.mc) : null;
  } catch (e) { MONEY = null; PAGE_FMT = null; }

  /* ?ow_preview=1 \u2014 run every feature even while Vitals is still installed (for the store owner's check). */
  var PREVIEW = false;
  try {
    var pm = /[?&]ow_preview=([01])(?:&|$)/.exec(W.location.search || '');
    if (pm) W.sessionStorage.setItem('ow_cb_preview', pm[1]);
    PREVIEW = W.sessionStorage.getItem('ow_cb_preview') === '1';
  } catch (e) {}
  function vitalsHas(n) {
    if (PREVIEW) return false;
    try { var m = W.vtlsLiquidData && W.vtlsLiquidData.moduleSettings; return !!(m && m[String(n)]); } catch (e) { return false; }
  }

  /* \u2500\u2500 One body observer shared by every feature \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var subs = [], obs = null;
  function dispatch(recs) {
    for (var i = 0; i < subs.length; i++) { try { subs[i](recs); } catch (e) { warn('observer', e); } }
    /* Our own writes made during this callback are not news for us. */
    if (obs) { try { obs.takeRecords(); } catch (e) {} }
  }
  function onDom(fn) {
    subs.push(fn);
    if (obs || !W.MutationObserver || !D.body) return;
    obs = new MutationObserver(dispatch);
    obs.observe(D.body, { childList: true, subtree: true, characterData: true });
  }
  /* Once per frame, whatever changed (sticky mirror, labels, cart note). */
  function onDomFrame(fn) {
    var queued = false;
    onDom(function () {
      if (queued) return;
      queued = true;
      raf(function () { queued = false; try { fn(); } catch (e) { warn('frame', e); } });
    });
  }

  /* Bottom offset for the fixed buttons while the sticky bar shows. */
  function setLift(px) { try { HTML.style.setProperty('--ow-cb-lift', (px > 0 ? px : 0) + 'px'); } catch (e) {} }

  /* \u2500\u2500 1. Currency converter \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  var OWB = { version: 1, base: BASE, currency: function () { return BASE; }, rate: function () { return 1; },
    format: function (cents, code) { return owFmt(Number(cents), code || BASE); }, convert: function (cents) { return Number(cents); },
    setCurrency: noop, onChange: noop,
    page: function () { return { currency: BASE, rate: 1, country: MONEY && typeof MONEY.country === 'string' ? MONEY.country : null }; },
    fromPage: function (u) { return Number(u); } };
  W.OWBooster = OWB;

  safe('currency', function () {
    var cur = C.currency;
    if (!cur || vitalsHas(30)) { unhold(); return; }
    /* The page (checkout) currency P: what Shopify printed \u2014 Shopify.currency.active, which must agree with
       Liquid's cart.currency (else the converter stays off). P = the store currency: the legacy path,
       unchanged (every store without Shopify local currencies \u2014 Stripe, or local currencies off). P \u2260 the
       store currency (owner 2026-10-07: "even when Shopify local payment is activated"): every price is read
       in P, turned back into store cents with Shopify's own rate, and converted. */
    var SC = W.Shopify && W.Shopify.currency;
    var active = SC && SC.active ? String(SC.active).toUpperCase() : null;
    var liq = MONEY && typeof MONEY.cur === 'string' && /^[A-Za-z]{3}$/.test(MONEY.cur) ? MONEY.cur.toUpperCase() : null;
    if (active && liq && active !== liq) { unhold(); return; }
    var PCUR = active || liq || BASE, PATHP = PCUR !== BASE;
    /* The currencies the store checks out in (Liquid localization.available_countries): more than one = MULTI. */
    var CS = [];
    if (MONEY && MONEY.cs && MONEY.cs.length) {
      for (var csi = 0; csi < MONEY.cs.length; csi++) { var csc = String(MONEY.cs[csi]).toUpperCase(); if (/^[A-Z]{3}$/.test(csc) && CS.indexOf(csc) === -1) CS.push(csc); }
    }
    var MULTI = PATHP || CS.length > 1;
    var RATE = 1;
    var usable = !!FX && !!FX.rates && String(FX.base).toUpperCase() === BASE && BASE === 'USD' && typeof WeakMap === 'function' && !!D.createTreeWalker;
    /* Only a format whose prices the reader can find ("$8.99"): on "US$8.99" / "8.99 USD" the selector
       and the cart notice would show while nothing converts (fix 2026-10-07). */
    if (!PATHP) usable = usable && owFormatOk(SHOP.moneyFormat);
    else {
      /* A strict rate within PAGE_RATE_MAX_GAP of the day's rate (Shopify's includes its conversion fee), and a
         page money format the reader can read back (else the page shows Shopify's own prices, untouched). */
      RATE = owRate(SC && SC.rate);
      usable = usable && RATE > 0 && owRateSane(RATE, FX.rates[PCUR]) && !!PAGE_FMT;
    }
    if (usable) {
      var age = Date.now() - Number(FX.ts);
      usable = age >= -129600000 && age <= 604800000;
    }
    if (!usable) { unhold(); return; }
    function convertible(code) { return !!code && code !== BASE && own(OW_CUR, code) && FX.rates[code] > 0; }
    /* The store owner's list: what EVERY shopper's box offers (the store currency first). */
    var OWNER = [BASE];
    for (var li = 0; li < (cur.list || []).length; li++) {
      var lc = String(cur.list[li]).toUpperCase();
      if (convertible(lc) && OWNER.indexOf(lc) === -1) OWNER.push(lc);
    }
    var AUTO = !!cur.auto;
    if (OWNER.length < 2 && !AUTO && !PATHP) { unhold(); return; }
    /* ow_cb_pp: on a store that checks out in several currencies, the page currency a pick was made on. */
    var CHOSEN = 'ow_cb_cur', GEO = 'ow_cb_geo', PP = 'ow_cb_pp', GEO_FRESH = 86400000, GEO_KEEP = 2592000000, PICK = '2:';
    var G = PATHP ? owStep(PAGE_FMT) : 1;
    var PX = { f: PAGE_FMT, r: RATE, g: G, base: BASE, rates: FX.rates, sym: {} };
    /* Every country -> its currency (fx.ts), expanded from "currency: the countries' letters run together". */
    var COUNTRY_CUR = {};
    for (var ck in OW_COUNTRIES) {
      if (!own(OW_COUNTRIES, ck)) continue;
      for (var ci = 0; ci + 1 < OW_COUNTRIES[ck].length; ci += 2) COUNTRY_CUR[OW_COUNTRIES[ck].substr(ci, 2)] = ck;
    }
    function currencyOf(country) { country = String(country || '').toUpperCase(); return /^[A-Z]{2}$/.test(country) && own(COUNTRY_CUR, country) ? COUNTRY_CUR[country] : null; }
    /* The visitor's country as Shopify last told it, with its currency ({c, k, t}); asked again after a day, used at most 30 days. */
    function geoRead() {
      try {
        var g = JSON.parse(lsGet(GEO) || 'null'), age = g ? Date.now() - g.t : NaN;
        if (g && typeof g.c === 'string' && /^[A-Z]{2}$/.test(g.c) && age < GEO_KEEP && age > -GEO_FRESH) return g;
      } catch (e) {}
      return null;
    }
    var geo = AUTO ? geoRead() : null;
    /* An entry the first runtime wrote ({c, t}: no currency) gets its currency at once, so the next
       page's head guard can hold the prices \u2014 it carries no country table (review 2026-10-07: until
       Shopify was asked again a day later, every page flashed $ prices first). */
    if (geo && !own(geo, 'k')) { geo.k = currencyOf(geo.c); lsSet(GEO, JSON.stringify({ c: geo.c, k: geo.k, t: geo.t })); }
    /* The shopper's OWN location currency when the converter can show it (owner 2026-10-07: "the customer
       location should be the main picked currency"), for every country \u2014 not only the owner's list. */
    var OWN = null;
    function setOwn(code) { OWN = AUTO && convertible(code) ? code : null; }
    if (geo) setOwn(typeof geo.k === 'string' ? geo.k : currencyOf(geo.c));
    /* This shopper's box: their own currency at the top when it is not in the owner's list (so a visitor
       from Thailand who switched to USD can always switch back to THB), then the page currency when it is
       not in it (what checkout charges: a NZ shopper can always go back to NZD), then the owner's list.
       Never stored in the owner's settings, never shown to anyone else. The currency shown and the hand
       pick follow ONE rule, shared with the head guard (owTarget): the shopper's pick (saved as PICK +
       code, "2:GBP"; a bare first-box "GBP" never hides their own location currency outside the owner's
       list \u2014 review 2026-10-07), else their location currency (on a store that checks out in several
       currencies only when Shopify cannot charge it), else the page currency. */
    var LIST = [];
    function decide() {
      return owTarget({ S: BASE, P: PCUR, cs: CS, multi: MULTI, owner: OWNER, own: OWN, raw: lsGet(CHOSEN), pp: MULTI ? lsGet(PP) : null, mark: PICK });
    }
    function rebuild() { var dd = decide(); LIST = dd.list; return dd; }
    var first = rebuild();
    if (LIST.length < 2 && !AUTO) { unhold(); return; }
    function valid(code) { return !!code && LIST.indexOf(code) !== -1; }
    function picked() { return decide().pick; }
    /* Once the shopper's own currency is known, a first-box pick is settled for good: kept (as a PICK
       pick) when their currency was in that box, dropped when it was not. */
    function settleOldPick() {
      var v = lsGet(CHOSEN);
      if (!v || !OWN || v.slice(0, PICK.length) === PICK) return;
      if (OWNER.indexOf(OWN) !== -1 && valid(v)) lsSet(CHOSEN, PICK + v);
      else { lsDel(CHOSEN); if (MULTI) lsDel(PP); }
    }

    /* The shopper's own pick wins (kept across pages and visits); otherwise their location's currency
       (see owTarget), otherwise the page currency. On a store that checks out in several currencies, a
       pick made on another page currency gives way \u2014 the shopper (or Shopify) changed the checkout
       currency since, and Shopify's newer choice wins: the page currency is shown and saved as their pick
       (review 2026-10-07: never their location currency instead \u2014 a Thai visitor who picked USD, then
       chose the UK in Shopify's selector, sees GBP on this page and the next); a pick made before ow_cb_pp
       existed is stamped with this page's currency and kept. */
    var current = first.t;
    if (first.drop) { lsSet(CHOSEN, PICK + PCUR); lsSet(PP, PCUR); }
    else if (first.stamp) lsSet(PP, PCUR);
    settleOldPick();

    var rec = new WeakMap(); /* text node \u2192 { o: original store-currency text, w: what we wrote, n: writes, t: first write ms } */
    var listeners = [];
    function skipped(el) {
      for (var e = el, d = 0; e && e !== D.body && d < 60; e = e.parentNode, d++) {
        if (e.nodeType !== 1) continue;
        var tn = e.nodeName;
        if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEXTAREA' || tn === 'TEMPLATE' || tn === 'TITLE' || tn === 'INPUT') return true;
        if (e.getAttribute && e.getAttribute('data-ow-noconv') !== null) return true;
        if (e.getAttribute && e.getAttribute('contenteditable') === 'true') return true;
        /* The review widget prints the customers' own words. (getAttribute: a form's .id can be its <input name="id">.) */
        var eid = e.getAttribute ? e.getAttribute('id') : null;
        if (eid && eid.indexOf('reviewify') === 0) return true;
        /* The theme's own country / currency selector ("New Zealand (NZD $)"): Shopify's choice, never ours. */
        if (tn === 'LOCALIZATION-FORM') return true;
        if (tn === 'FORM' && /\/localization/.test(e.getAttribute('action') || '')) return true;
        if ((' ' + (e.getAttribute('class') || '') + ' ').indexOf(' localization-form ') !== -1) return true;
      }
      return false;
    }
    /* \u2500\u2500 Shopify local-currency pages (P \u2260 the store currency) \u2500\u2500
       A marked amount (data-ow-money + data-ow-cur, the bundle box contract, docs 19 \u00a74.1.1) is decided by ITS OWN
       currency, inside the box or not (review 2026-10-07: the box's store-currency fallback marks every amount USD
       and puts nothing on its root \u2014 it used to be skipped whole). Unmarked text inside #kbBox (pack titles, an
       older box's store-currency prices) is never read as P; the add-to-cart label the box writes is read as P only
       when the box declares it prints in P (data-ow-cur or data-kb-fx = P on #kbBox, or every marked amount in P). */
    function boxDeclares(kb) {
      var dc = kb.getAttribute('data-ow-cur') || kb.getAttribute('data-kb-fx');
      if (dc) return String(dc).toUpperCase() === PCUR;
      var all = kb.querySelectorAll('[data-ow-cur]');
      if (!all.length) return false;
      for (var i = 0; i < all.length; i++) if (String(all[i].getAttribute('data-ow-cur')).toUpperCase() !== PCUR) return false;
      return true;
    }
    /* The marks an element carried when we first read it (2026-10-07 integration): the box's v7 section takes the
       label's marks away as soon as its text no longer holds data-ow-amt \u2014 i.e. once we converted it \u2014 so a later
       switch (USD, then GBP) and the switch back to P read them from here; back on P they are put back as printed. */
    var MARKS = ['data-ow-money', 'data-ow-cur', 'data-ow-amt', 'data-ow-base'], markMem = new WeakMap();
    function markedOf(p, orig) {
      if (!(p && p.nodeType === 1 && p.closest)) return null;
      var el = p.closest('[data-ow-money]');
      if (el) {
        var keep = [];
        for (var i = 0; i < 4; i++) keep.push(el.getAttribute(MARKS[i]));
        markMem.set(el, keep);
        return el;
      }
      for (var e = p, d = 0; e && e.nodeType === 1 && d < 4; e = e.parentNode, d++) {
        var m = markMem.get(e);
        if (m) return orig == null || (m[2] != null && String(orig).indexOf(m[2]) !== -1) ? e : null;
      }
      return null;
    }
    function markAttr(mk, i) {
      var v = mk.getAttribute(MARKS[i]);
      if (v !== null) return v;
      var m = markMem.get(mk);
      return m ? m[i] : null;
    }
    function markBack(mk) {
      var m = markMem.get(mk);
      if (!m || mk.getAttribute(MARKS[0]) !== null) return;
      for (var i = 0; i < 4; i++) if (m[i] !== null) mk.setAttribute(MARKS[i], m[i]);
    }
    function boxBlocks(p, orig) {
      var kb = D.getElementById('kbBox');
      if (!kb) return false;
      var inBox = kb.contains(p);
      if (!inBox && !(p.closest && p.closest('[id^="ProductSubmitButton"]'))) return false;
      if (markedOf(p, orig)) return false;
      return inBox || !boxDeclares(kb);
    }
    /* A marked amount: converted from its attributes only. In P: the text must read as the marked value (Shopify
       money units, or ISO minor units for a 0-decimal currency). In the store currency: the exact store cents \u2014
       while the shopper sees P it is shown as the store price with a symbol P's reader cannot read ("US$16.20" on
       a $ page: never a made-up P price, which Markets rounding would make differ from Shopify's), in any other
       currency converted; only the amount is replaced ("Add 4 \u2013 $15.99" keeps its words), and only when it is
       there exactly once and reads as the mark. Anything else: left. */
    function markedOut(mk, orig) {
      var X = String(markAttr(mk, 1) || '').toUpperCase(), mv = String(markAttr(mk, 0) || '');
      if (!/^-?\d+$/.test(mv) || !/\d/.test(orig)) return null;
      var mm = Math.abs(parseInt(mv, 10)), bv = markAttr(mk, 3);
      var hint = bv != null && /^-?\d+$/.test(bv) ? Math.abs(parseInt(bv, 10)) : null;
      if (X === PCUR) {
        if (current === PCUR) { markBack(mk); return null; }
        var hits = owPageHits(orig, PAGE_FMT);
        if (hits.length !== 1) return null;
        var u = hits[0].u;
        if (mm !== u && mm * (PAGE_FMT.dec === 0 ? 100 : 1) !== u) return null;
        return orig.slice(0, hits[0].i) + owPageAmt(u, current, PX, hint) + orig.slice(hits[0].i + hits[0].n);
      }
      if (X === BASE) return owStoreSplice(orig, markAttr(mk, 2), mm, owStoreIn(mm, current === PCUR ? BASE : current, PX));
      return null;
    }
    /* Cart lines (review 2026-10-07): Shopify converts the UNIT price, then multiplies, and the total is the sum of the
       lines less the cart discounts \u2014 so a line total of a row with q units is q x its unit's store cents, and a
       total that is exactly that sum is the sum of the store values (the US page's own numbers, to the cent). */
    var DRAWER = 'cart-drawer, #CartDrawer, .cart-drawer';
    /* An element's text as the page printed it (our own writes undone); skip: leave out text inside those parts of it. */
    function textOf(el, skip) {
      var out = '', tw = D.createTreeWalker(el, 4, null, false), n;
      while ((n = tw.nextNode())) {
        var sk = skip && n.parentNode && n.parentNode.closest ? n.parentNode.closest(skip) : null;
        if (sk && sk !== el && el.contains(sk)) continue;
        var r = rec.get(n);
        out += r && n.nodeValue === r.w ? r.o : n.nodeValue;
      }
      return out;
    }
    function rowQty(row) {
      var inp = row.querySelector('input[name="updates[]"], .quantity__input');
      var v = inp ? String(inp.getAttribute('value') || inp.value || '') : '';
      return /^\d{1,5}$/.test(v) && Number(v) > 0 ? Number(v) : 1;
    }
    /* The units a line-total amount stands for: the row's quantity inside its totals cell (not a unit price). */
    function lineQty(p) {
      if (!p.closest || !p.closest('.cart-item__totals') || p.closest('.unit-price')) return 1;
      var row = p.closest('.cart-item');
      return row ? rowQty(row) : 1;
    }
    function cartTotalStore(p, u) {
      if (!p.closest || !p.closest('.totals__total-value, .totals__subtotal-value')) return null;
      var dr = p.closest(DRAWER), scope = dr || D, rows = scope.querySelectorAll('.cart-item'), L = 0, Ls = 0, n = 0, i;
      for (i = 0; i < rows.length; i++) {
        if (!dr && rows[i].closest(DRAWER)) continue;
        var cell = rows[i].querySelector('.cart-item__totals');
        var hs = cell ? owPageHits(textOf(cell, 's, del, .unit-price'), PAGE_FMT) : [];
        if (hs.length !== 1) return null;
        L += hs[0].u; Ls += owRecoverLine(hs[0].u, rowQty(rows[i]), RATE, G); n++;
      }
      if (!n) return null;
      if (u === L) return Ls;
      var ds = scope.querySelectorAll('.discounts__discount'), Du = 0, Ds = 0;
      for (i = 0; i < ds.length; i++) {
        if (ds[i].closest('.cart-item') || (!dr && ds[i].closest(DRAWER))) continue;
        var dt = textOf(ds[i]);
        if (!owPageHits(dt, PAGE_FMT).length) continue;
        var dh = owPickHits(dt, PAGE_FMT, 'discount');
        if (dh.length !== 1) return null;
        Du += dh[0].u; Ds += owRecover(dh[0].u, RATE, G);
      }
      return u === L - Du ? Ls - Ds : null;
    }
    /* What a node shows on a P page; null = its own text (P, as Shopify printed it). */
    function pageOut(p, orig) {
      if (boxBlocks(p, orig)) return null;
      var mk = markedOf(p, orig);
      if (mk) return markedOut(mk, orig);
      if (current === PCUR) return null;
      if (!(p.nodeType === 1 && p.closest && p.closest(PRICE_SCOPE))) return null;
      /* Inside a discount ("<the owner's title> (-amount)") and Dawn's unit-price / option spots, only Dawn's own amount
         is read; an option or property value (dt / dd) never (review 2026-10-07: "Get $5 off" is the owner's USD). */
      var lim = p.closest('.discounts__discount, .product-option'), kind = 'all';
      if (lim) {
        var dd = p.closest('dt, dd');
        if (dd && lim.contains(dd)) return null;
        kind = lim.matches && lim.matches('.discounts__discount') ? 'discount' : 'option';
      }
      var hits = owPickHits(orig, PAGE_FMT, kind);
      if (!hits.length) return null;
      var q = lineQty(p), tot = null;
      if (hits.length === 1 && /^\s*$/.test(orig.slice(0, hits[0].i) + orig.slice(hits[0].i + hits[0].n))) tot = cartTotalStore(p, hits[0].u);
      var out = '', at = 0;
      for (var i = 0; i < hits.length; i++) {
        var sc = tot != null ? tot : owRecoverLine(hits[i].u, q, RATE, G);
        out += orig.slice(at, hits[i].i) + owStoreIn(sc, current, PX);
        at = hits[i].i + hits[i].n;
      }
      return out + orig.slice(at);
    }
    var SIGS = [];
    if (PATHP) {
      for (var sgi = 0; sgi < PAGE_FMT.parts.length; sgi++) {
        var sgp = PAGE_FMT.parts[sgi], sg = sgp.pre ? sgp.pre.replace(/^\s+/, '').charAt(0) : sgp.suf.replace(/\s+$/, '').slice(-1);
        if (sg && SIGS.indexOf(sg) === -1) SIGS.push(sg);
      }
    }
    /* Worth a look: a "$" amount (store-currency pages); on P pages a digit with the format's sign, or a marked amount. */
    function wanted(n) {
      var v = n.nodeValue;
      if (!v) return false;
      if (!PATHP) return v.indexOf('$') !== -1;
      if (!/\d/.test(v)) return false;
      /* Shown as Shopify printed it: only a marked store-currency amount (the box fallback) needs work. */
      if (current === PCUR) return !!markedOf(n.parentNode);
      for (var i = 0; i < SIGS.length; i++) if (v.indexOf(SIGS[i]) !== -1) return true;
      return !!markedOf(n.parentNode);
    }
    var touchedButton = false;
    /* Loop guard. Another script that writes a price back to "$\u2026" each time we convert it (a
       second converter, a widget re-rendering from its own copy) would make the two observers
       call each other forever \u2014 inside one task, so the page would freeze. Every conversion
       that follows someone else's write (a new text node, or a node rewritten in place) is
       counted per parent element: more than 40 in 10 s and that element is left exactly as the
       other script writes it for the rest of the page view. Re-applying our own text (a
       currency switch) is not counted; a shopper switching packs makes 1 per switch. */
    var FIGHT_MAX = 40, FIGHT_MS = 10000;
    var fights = new WeakMap(); /* parent element \u2192 { n, t, x } */
    function gaveUp(el) { var f = el ? fights.get(el) : null; return !!(f && f.x); }
    function foreignWriteOk(el) {
      if (!el) return true;
      var now = Date.now(), f = fights.get(el);
      if (!f || now - f.t > FIGHT_MS) { f = { n: 0, t: now, x: false }; fights.set(el, f); }
      if (++f.n <= FIGHT_MAX) return true;
      f.x = true;
      warn('price', 'another script keeps rewriting a price; it is left as that script writes it');
      return false;
    }
    function apply(n) {
      var p = n.parentNode;
      if (!p) return; /* already replaced: nothing to show */
      var v = n.nodeValue, r = rec.get(n);
      var foreign = !r;
      if (r) {
        if (r.x) return;
        if (v !== r.w) { rec.delete(n); r = null; foreign = true; } /* someone else changed it: what they wrote is the new original */
      }
      var orig = r ? r.o : v, out;
      if (!orig) return;
      if (PATHP) {
        if (!/\d/.test(orig)) return;
        if (!r && skipped(p)) return;
        out = pageOut(p, orig);
        if (out == null || out === orig) {
          if (r) { rec.delete(n); if (n.nodeValue !== r.o) n.nodeValue = r.o; }
          return;
        }
        if (gaveUp(p)) return;
      } else {
        if (orig.indexOf('$') === -1) return;
        if (!r && skipped(p)) return;
        if (current === BASE) {
          if (r) { rec.delete(n); if (n.nodeValue !== r.o) n.nodeValue = r.o; }
          return;
        }
        if (gaveUp(p)) return;
        out = owConvertText(orig, FX.rates[current], current);
        if (out == null) return;
      }
      if (foreign && !foreignWriteOk(p)) return;
      var now = Date.now();
      if (r) {
        /* A node rewritten to our own text over and over (never by us) is left alone too. */
        if (now - r.t > 10000) { r.t = now; r.n = 0; }
        if (++r.n > 25) { r.x = true; return; }
      } else r = { o: orig, w: out, n: 1, t: now };
      r.o = orig; r.w = out;
      if (n.nodeValue !== out) n.nodeValue = out;
      rec.set(n, r);
      if (n.parentNode && n.parentNode.closest && n.parentNode.closest('[id^="ProductSubmitButton"]')) touchedButton = true;
    }
    function collect(root, out) {
      if (!root) return;
      if (root.nodeType === 3) { if (wanted(root) || rec.has(root)) out.push(root); return; }
      if (root.nodeType !== 1 && root.nodeType !== 11) return;
      var tn = root.nodeName;
      if (tn === 'SCRIPT' || tn === 'STYLE' || tn === 'NOSCRIPT' || tn === 'TEMPLATE' || tn === 'TEXTAREA') return;
      var tw = D.createTreeWalker(root, 4, null, false), n;
      while ((n = tw.nextNode())) { if (wanted(n) || rec.has(n)) out.push(n); }
    }
    /* The converted label can be wider than the store-currency one the bundle box measured:
       shorten it the same way the box does ("Add 4 patterns \u2013 \u00a3x" \u2192 "Add 4 \u2013 \u00a3x" \u2192 "Add \u2013 \u00a3x" \u2192 "\u00a3x").
       (The sticky bar is data-ow-noconv and fits its own copy of the label: see fitSticky.) */
    function refit(btnLabel) {
      if (!btnLabel || btnLabel.childNodes.length !== 1 || btnLabel.firstChild.nodeType !== 3) return;
      var n = btnLabel.firstChild, r = rec.get(n);
      if (!r) return;
      var fits = function () { try { return btnLabel.scrollWidth <= btnLabel.clientWidth + 1; } catch (e) { return true; } };
      if (fits()) return;
      var full = n.nodeValue, m = /^(.*?)\s+\u2013\s+(.+)$/.exec(full);
      if (!m) return;
      var cnt = /^Add (\d+)\b/.exec(m[1]);
      var options = [];
      if (cnt && m[1] !== 'Add ' + cnt[1]) options.push('Add ' + cnt[1] + ' \u2013 ' + m[2]);
      options.push('Add \u2013 ' + m[2], m[2]);
      for (var i = 0; i < options.length; i++) {
        n.nodeValue = options[i];
        r.w = options[i];
        if (fits()) return;
      }
    }
    function refitButtons() {
      if (!touchedButton) return;
      touchedButton = false;
      var labels = D.querySelectorAll('[id^="ProductSubmitButton"] > span');
      for (var i = 0; i < labels.length; i++) refit(labels[i]);
    }
    function applyAll() {
      var list = [];
      collect(D.body, list);
      for (var i = 0; i < list.length; i++) applySafe(list[i]);
      refitButtons();
    }
    /* One odd node never stops the converter. */
    function applySafe(n) { try { apply(n); } catch (e) { warn('price', e); } }
    function onMutations(recs) {
      var list = [];
      for (var i = 0; i < recs.length; i++) {
        var m = recs[i];
        if (m.type === 'characterData') { if (m.target.nodeType === 3) list.push(m.target); }
        else if (m.addedNodes) for (var j = 0; j < m.addedNodes.length; j++) collect(m.addedNodes[j], list);
      }
      if (!list.length) return;
      for (var k = 0; k < list.length; k++) {
        var n = list[k], r = rec.get(n);
        if (r && n.nodeValue === r.w) continue; /* ours */
        if (current === PCUR && !r && !(PATHP && markedOf(n.parentNode))) continue;
        applySafe(n);
      }
      refitButtons();
    }

    /* Cart page: the shopper is told which currency checkout charges \u2014 the page currency (the store
       currency, or their local currency when Shopify charges it). */
    var NOTE_ID = 'ow-cb-cart-note';
    function cartNote() {
      if (!cur.note || PAGE.t !== 'cart') return;
      var el = D.getElementById(NOTE_ID);
      if (current === PCUR) { if (el) el.hidden = true; return; }
      var txt = 'Prices shown here are calculated in ' + current + ', but the final order will be paid in ' + PCUR + '.';
      if (!el) {
        var blocks = D.querySelector('#main-cart-footer .cart__blocks') || D.querySelector('.cart__blocks');
        var totals = D.querySelector('.totals');
        if (!blocks && !totals) return;
        el = D.createElement('p');
        el.id = NOTE_ID;
        el.className = 'ow-cb-cart-note';
        el.setAttribute('data-ow-noconv', '');
        el.setAttribute('role', 'note');
        textNode(el, '');
        if (blocks) {
          var after = blocks.querySelector(':scope > .js-contents');
          if (after && after.nextSibling) blocks.insertBefore(el, after.nextSibling);
          else if (after) blocks.appendChild(el);
          else blocks.insertBefore(el, blocks.firstChild);
        } else totals.parentNode.insertBefore(el, totals.nextSibling);
      }
      setText(el.firstChild, txt);
      el.hidden = false;
    }

    /* Selector, fixed bottom-left (or right). */
    var sel = null;
    var WIN = false;
    try { WIN = /Windows/i.test((W.navigator && W.navigator.userAgent) || ''); } catch (e) {}
    /* A drawn flag ("w h|<shapes>", wrapped here); else the emoji built from the two country letters \u2014
       Windows draws an emoji flag as two plain letters, so there a small neat box with them instead. */
    function flag(code) {
      if (own(FLAG_SVG, code)) {
        var f = FLAG_SVG[code], bar = f.indexOf('|');
        return '<span class="ow-cb-flag"><svg viewBox="0 0 ' + f.slice(0, bar) + '" preserveAspectRatio="none" aria-hidden="true">' + f.slice(bar + 1) + '</svg></span>';
      }
      var cc = own(FLAG_CC, code) ? FLAG_CC[code] : '';
      if (/^[A-Z]{2}$/.test(cc)) {
        if (WIN) return '<span class="ow-cb-flag ow-cb-flag--txt" aria-hidden="true">' + cc + '</span>';
        cc = String.fromCharCode(0xD83C, 0xDDE6 + cc.charCodeAt(0) - 65, 0xD83C, 0xDDE6 + cc.charCodeAt(1) - 65);
      }
      return '<span class="ow-cb-flag ow-cb-flag--emoji" aria-hidden="true">' + cc + '</span>';
    }
    function buildSelector() {
      var wrap = D.createElement('div');
      wrap.className = 'ow-cb-cur ow-cb-fixed ow-cb-cur--' + (cur.pos === 'bottom_right' ? 'br' : 'bl');
      wrap.setAttribute('data-ow-noconv', '');
      wrap.style.setProperty('--ow-cur-bg', cur.bg || '#ffffff');
      wrap.style.setProperty('--ow-cur-bd', cur.bd || '#f4f4f4');
      wrap.style.setProperty('--ow-cur-fg', cur.fg || '#111111');
      wrap.style.setProperty('--ow-cur-fs', (cur.fs || 14) + 'px');
      var btn = D.createElement('button');
      btn.type = 'button';
      btn.className = 'ow-cb-cur__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      var list = D.createElement('ul');
      list.className = 'ow-cb-cur__list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Currency');
      list.hidden = true;
      var made = {};
      function optionFor(code) {
        if (own(made, code)) return made[code];
        var li = D.createElement('li');
        li.setAttribute('role', 'option');
        li.setAttribute('data-code', code);
        li.tabIndex = -1;
        li.className = 'ow-cb-cur__opt';
        li.innerHTML = flag(code) + '<span class="ow-cb-cur__code">' + code + '</span><span class="ow-cb-cur__name">' + (own(OW_CUR, code) ? OW_CUR[code][2] : '') + '</span>';
        made[code] = li;
        return li;
      }
      /* The options follow LIST without ever removing a node (the cart guard re-checks the cart on
         removed nodes): the owner's list in order; the shopper's own currency on top; an own currency
         that is no longer theirs is only hidden. */
      var POPT = PATHP && OWNER.indexOf(PCUR) === -1 ? PCUR : null;
      function fill() {
        for (var i = 0; i < OWNER.length; i++) { var o = optionFor(OWNER[i]); if (!o.parentNode) list.appendChild(o); }
        /* The page currency (what checkout charges) right above the owner's list. */
        if (POPT) { var po = optionFor(POPT); if (!po.parentNode) list.insertBefore(po, optionFor(OWNER[0])); }
        for (var k in made) if (own(made, k) && OWNER.indexOf(k) === -1) made[k].hidden = k !== OWN && k !== POPT;
        if (OWN && OWNER.indexOf(OWN) === -1) { var t = optionFor(OWN); if (!t.parentNode) list.insertBefore(t, list.firstChild); t.hidden = false; }
      }
      function shownItems() {
        var out = [];
        for (var i = 0; i < list.children.length; i++) if (!list.children[i].hidden) out.push(list.children[i]);
        return out;
      }
      fill();
      wrap.appendChild(list);
      wrap.appendChild(btn);
      function paint() {
        btn.innerHTML = flag(current) + '<span class="ow-cb-cur__code">' + current + '</span><span class="ow-cb-cur__caret" aria-hidden="true"></span>';
        btn.setAttribute('aria-label', 'Currency: ' + current + '. Change currency');
        var opts = list.children;
        for (var j = 0; j < opts.length; j++) opts[j].setAttribute('aria-selected', opts[j].getAttribute('data-code') === current ? 'true' : 'false');
      }
      function open() {
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        var on = list.querySelector('[aria-selected="true"]:not([hidden])') || shownItems()[0];
        if (on) on.focus();
      }
      function close(focusBtn) {
        if (list.hidden) return;
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (focusBtn) btn.focus();
      }
      btn.addEventListener('click', function (e) { e.preventDefault(); if (list.hidden) open(); else close(false); });
      list.addEventListener('click', function (e) {
        var li = e.target && e.target.closest ? e.target.closest('[data-code]') : null;
        if (!li || li.hidden) return;
        setCurrency(li.getAttribute('data-code'), true);
        close(true);
      });
      list.addEventListener('keydown', function (e) {
        var items = shownItems(), at = -1;
        for (var k = 0; k < items.length; k++) if (items[k] === D.activeElement) at = k;
        if (!items.length) return;
        if (e.key === 'ArrowDown') { e.preventDefault(); items[Math.min(items.length - 1, at + 1)].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); items[Math.max(0, at - 1)].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (at >= 0) { setCurrency(items[at].getAttribute('data-code'), true); close(true); } }
        else if (e.key === 'Escape' || e.key === 'Tab') close(e.key === 'Escape');
      });
      D.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); }, true);
      D.body.appendChild(wrap);
      paint();
      return { paint: paint, fill: function () { fill(); paint(); } };
    }

    function setCurrency(code, byShopper) {
      code = String(code || '').toUpperCase();
      if (!valid(code)) return;
      if (byShopper) { lsSet(CHOSEN, PICK + code); if (MULTI) lsSet(PP, PCUR); }
      if (code === current) return;
      current = code;
      applyAll();
      if (obs) { try { obs.takeRecords(); } catch (e) {} }
      if (sel) sel.paint();
      safe('cart note', cartNote);
      for (var i = 0; i < listeners.length; i++) { try { listeners[i](current); } catch (e) {} }
      try { D.dispatchEvent(new CustomEvent('ow:currency', { detail: { currency: current, base: BASE, page: PCUR } })); } catch (e) {}
    }

    OWB.currency = function () { return current; };
    /* Store cents in, as before; on a P page "P" means what Shopify charges (its own rate). */
    OWB.rate = function (code) { code = code || current; return code === BASE ? 1 : code === PCUR ? RATE : (FX.rates[code] || null); };
    OWB.convert = function (cents) { cents = Number(cents); return current === BASE ? cents : current === PCUR ? owFwd(cents, RATE, G) : owConv(cents, FX.rates[current], current); };
    OWB.format = function (cents, code) {
      code = code || current; cents = Number(cents);
      if (PATHP) return code === PCUR ? owPageFmt(owFwd(cents, RATE, G), PAGE_FMT) : owStoreIn(cents, code, PX);
      return code === BASE ? owFmt(cents, BASE) : owFmt(owConv(cents, FX.rates[code], code), code);
    };
    OWB.page = function () { return { currency: PCUR, rate: RATE, country: MONEY && typeof MONEY.country === 'string' ? MONEY.country : null }; };
    OWB.fromPage = function (u) { return PATHP ? owRecover(Number(u), RATE, G) : Number(u); };
    /* An amount ALREADY in code (hundredths of its major unit, the converter's own units: JPY in steps of 100, KWD of 0.1)
       printed exactly the way this page prints its converted prices (2026-10-19, the store credit in the shopper's
       currency \u2014 storeCreditDisplay.ts owCreditCtx), and the step of those units. Only while the converter runs. */
    OWB.step = function (code) {
      code = String(code || '').toUpperCase();
      if (PATHP && code === PCUR) return G;
      var info = own(OW_CUR, code) ? OW_CUR[code] : null;
      return info ? (info[1] === 0 ? 100 : info[1] === 3 ? 0.1 : 1) : null;
    };
    OWB.print = function (units, code) {
      code = String(code || '').toUpperCase(); units = Number(units);
      if (!PATHP) return owFmt(units, code);
      if (code === PCUR) return owPageFmt(units, PAGE_FMT);
      if (PX.sym[code] == null) PX.sym[code] = owSafeSym(code, PAGE_FMT);
      return owFmt(units, code, PX.sym[code]);
    };
    OWB.setCurrency = function (code) { setCurrency(code, true); };
    OWB.onChange = function (fn) { if (typeof fn === 'function') listeners.push(fn); };
    OWB.currencies = function () { return LIST.slice(); };

    /* Back/forward cache: a restored page keeps its live state, so a currency chosen on another page
       meanwhile (Back after choosing EUR on the cart) would show the old one (fix 2026-10-07). */
    W.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) return;
      /* Only a pick made on THIS page currency (a cached page keeps its own P; nothing is deleted here). */
      safe('currency', function () { var m = picked(); if (m && m !== current) setCurrency(m, false); });
    });

    applyAll();
    unhold();
    onDom(onMutations);
    onDomFrame(function () { if (current !== PCUR && PAGE.t === 'cart' && !D.getElementById(NOTE_ID)) cartNote(); });
    safe('cart note', cartNote);
    safe('currency selector', function () { if (LIST.length >= 2) sel = buildSelector(); });

    /* The visitor's country \u2014 Shopify's own lookup, asked at most once a day (remembered with its
       currency). Asked even after the shopper picked a currency by hand: their own currency must stay
       in their box. It never overrides that pick. */
    function follow(country) {
      var was = OWN;
      setOwn(currencyOf(country));
      var dd = rebuild();
      if (OWN !== was) {
        if (sel) sel.fill();
        else if (LIST.length >= 2) safe('currency selector', function () { sel = buildSelector(); });
      }
      var want = dd.t;
      settleOldPick();
      if (want !== current) setCurrency(want, false);
    }
    if (AUTO && (!geo || Date.now() - geo.t >= GEO_FRESH) && W.fetch) {
      // Same call as the country-redirect snippet proven live on the stores (countryRedirectInstaller.ts).
      W.fetch(ROOT + 'browsing_context_suggestions.json?country%5Benabled%5D=true', { credentials: 'omit', headers: { Accept: 'application/json' } })
        .then(function (r) { return r && r.ok ? r.json() : null; })
        .then(function (j) {
          var dc = j && j.detected_values && j.detected_values.country;
          var c = dc && (dc.handle || dc.iso_code);
          if (!c || !/^[A-Za-z]{2}$/.test(c)) return;
          c = String(c).toUpperCase();
          lsSet(GEO, JSON.stringify({ c: c, k: currencyOf(c), t: Date.now() }));
          safe('currency', function () { follow(c); });
        })['catch'](noop);
    }
  });
  unhold();

  /* \u2500\u2500 2. Sticky add to cart \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('sticky', function () {
    var st = C.sticky;
    if (!st || !PRODUCT || vitalsHas(16)) return;
    function findForm() {
      var f = D.querySelector('form[data-type="add-to-cart"]');
      if (!f) { var pf = D.querySelector('product-form'); if (pf) f = pf.querySelector('form'); }
      if (!f) f = D.querySelector('form[action*="/cart/add"]');
      return f;
    }
    function findButton() {
      var f = findForm(), b = null;
      if (f) b = f.querySelector('button[type="submit"][name="add"]') || f.querySelector('button[type="submit"]') || f.querySelector('.product-form__submit');
      return b || D.querySelector('[id^="ProductSubmitButton"]');
    }
    var themeBtn = findButton();
    if (!themeBtn) return;
    function labelOf(b) {
      if (!b) return '';
      if (b.tagName === 'INPUT') return cleanText(b.value);
      var s = b.querySelector('span');
      return cleanText(s ? s.textContent : b.textContent);
    }
    function priceText() {
      var info = themeBtn.closest ? themeBtn.closest('.product__info-container, [id^="ProductInfo-"], .product') : null;
      var box = (info && info.querySelector('[id^="price-"] .price')) || D.querySelector('[id^="price-template"] .price') || null;
      if (!box) return '';
      var sale = (' ' + box.className + ' ').indexOf(' price--on-sale ') !== -1;
      var el = sale ? box.querySelector('.price__sale .price-item--sale') : box.querySelector('.price__regular .price-item--regular');
      return cleanText(el ? el.textContent : '');
    }
    /* The theme's price block of the CURRENT variant: its compare-at price, only while Dawn shows the
       variant on sale (compare-at above the price) \u2014 already in the shopper's currency. */
    function compareText() {
      var info = themeBtn.closest ? themeBtn.closest('.product__info-container, [id^="ProductInfo-"], .product') : null;
      var box = (info && info.querySelector('[id^="price-"] .price')) || D.querySelector('[id^="price-template"] .price') || null;
      if (!box || (' ' + box.className + ' ').indexOf(' price--on-sale ') === -1) return '';
      var el = box.querySelector('.price__sale s') || box.querySelector('.price__sale .price-item--regular');
      return cleanText(el ? el.textContent : '');
    }
    function shownEl(el) { try { return !!el && el.getClientRects().length > 0; } catch (e) { return false; } }
    /* The bundle box's OWN struck price of the selected pack ("\u00a324.75" in "\u00a324.75 separately", the
       classic box's full price) \u2014 read from the box, never computed here; '' when it shows none. */
    function packStrike() {
      var kb = D.getElementById('kbBox');
      if (!kb) return '';
      var views = kb.querySelectorAll('.kb-v'), root = null;
      for (var i = 0; i < views.length && !root; i++) if (shownEl(views[i])) root = views[i];
      var bar = (root || kb).querySelector('.kb-bar--selected');
      if (!bar) return '';
      var cands = bar.querySelectorAll('s, del, .kb-bar-full-price');
      for (var j = 0; j < cands.length; j++) {
        var t = cleanText(cands[j].textContent);
        if (/\d/.test(t) && shownEl(cands[j])) return t;
      }
      return '';
    }
    var bar = D.createElement('div');
    bar.className = 'ow-cb-sticky' + (st.mobile ? '' : ' ow-cb-sticky--nomob') + (st.desktop ? '' : ' ow-cb-sticky--nodesk');
    bar.setAttribute('data-ow-noconv', '');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.setAttribute('aria-hidden', 'true');
    bar.style.setProperty('--ow-st-bg', st.bg || '#ffffff');
    bar.style.setProperty('--ow-st-fg', st.fg || '#2e2e2e');
    bar.style.setProperty('--ow-st-btn-bg', st.btnBg || '#000000');
    bar.style.setProperty('--ow-st-btn-fg', st.btnFg || '#ffffff');
    var inner = D.createElement('div'); inner.className = 'ow-cb-sticky__in'; bar.appendChild(inner);
    if (PRODUCT.img) {
      var img = D.createElement('img');
      img.className = 'ow-cb-sticky__img'; img.alt = ''; img.width = 44; img.height = 44; img.loading = 'lazy'; img.decoding = 'async';
      img.src = String(PRODUCT.img);
      inner.appendChild(img);
    }
    var info = D.createElement('div'); info.className = 'ow-cb-sticky__info'; inner.appendChild(info);
    var titleEl = D.createElement('div'); titleEl.className = 'ow-cb-sticky__title'; info.appendChild(titleEl);
    var titleT = textNode(titleEl, PRODUCT.title || '');
    /* The price, then the old price struck through (like Vitals): "\u0e3f302.96 \u0e3f495.39". */
    var priceEl = D.createElement('div'); priceEl.className = 'ow-cb-sticky__price'; info.appendChild(priceEl);
    var nowEl = D.createElement('span'); nowEl.className = 'ow-cb-sticky__now'; priceEl.appendChild(nowEl);
    var priceT = textNode(nowEl, '');
    var wasEl = D.createElement('s'); wasEl.className = 'ow-cb-sticky__was'; priceEl.appendChild(wasEl);
    var wasT = textNode(wasEl, '');
    var btn = D.createElement('button'); btn.type = 'button'; btn.className = 'ow-cb-sticky__btn'; inner.appendChild(btn);
    var btnSpan = D.createElement('span'); btn.appendChild(btnSpan);
    var btnT = textNode(btnSpan, st.label || 'Add to Cart');
    D.body.appendChild(bar);

    /* "RM 58.76" (MYR) has neither a "$" nor a currency sign: every symbol the table prints counts
       (letters only when not inside a word), plus the old signs / "ABC 12" test (fix 2026-10-07). */
    var SYM_PRICE = (function () {
      var alts = ['\\$'];
      for (var k in OW_CUR) {
        if (!Object.prototype.hasOwnProperty.call(OW_CUR, k)) continue;
        var y = String(OW_CUR[k][0]).replace(/\s+$/, '');
        if (y) alts.push(y.replace(/[.*+?^$(){}|[\]\\]/g, '\\$&'));
      }
      return new RegExp('(?:^|[^A-Za-z])(?:' + alts.join('|') + ')\\s?\\d');
    })();
    /* A pack label in a currency written AFTER the amount ("Add 4 \u2013 170,10 kr SEK", "59,13 z\u0142",
       "1 234 Ft") counts too (fix round 2026-10-07): an amount with its cents or a thousands group, then the
       code as a whole word or the sign ("Add 4 PATTERNS", "Buy 2 NOW" are not prices). */
    var SUF_PRICE = /(?:\d[.,]\d\d|\d[\s\u00a0\u202f.,']\d{3})[\s\u00a0\u202f]?(?:[A-Z]{3}\b|kr\b|z\u0142|K\u010d|Ft\b|lei\b|\u20ab|\u043b\u0432|\u20bd|\u20b4|\u20b8|\u20ba)/;
    function labelHasPrice(label) {
      if (!/\d/.test(label)) return false;
      if (/[$\u00a3\u20ac\u00a5\u20b9\u20a9\u20aa\u20ba\u20b1\u0e3f]|[A-Z]{3}\s?\d/.test(label) || SYM_PRICE.test(label) || SUF_PRICE.test(label)) return true;
      /* The page's own money format reads it ("27,54 kr" on a Shopify local-currency page). */
      try { return !!PAGE_FMT && owPageHits(label, PAGE_FMT).length > 0; } catch (e) { return false; }
    }
    /* The bundle box marks its pack label with the price it shows (data-ow-amt, KB_FX_JS / the v7 section): a
       label carrying its own marked price is priced, whatever its currency's way of writing it. */
    function labelMarked(b, label) {
      if (!b || !b.getAttribute) return false;
      var el = b.getAttribute('data-ow-amt') !== null ? b : (b.querySelector ? b.querySelector('[data-ow-amt]') : null);
      var amt = el ? el.getAttribute('data-ow-amt') : null;
      return !!amt && String(label).indexOf(amt) !== -1;
    }
    var shown = false, past = false, lastTap = 0, srcLabel = null;
    /* The bar's button is narrower than the theme's (max 60% / 62% of the bar), so the pack label
       the bundle box fitted to the full-width theme button can be cut at its END \u2014 the price.
       Shorten our own copy the box's way ("Add 4 patterns \u2013 \u00a3x" \u2192 "Add 4 \u2013 \u00a3x" \u2192 "Add \u2013 \u00a3x" \u2192
       "\u00a3x"), whatever the currency (USD too). Written only when the source label changes (sync
       runs after every page change; writing full-then-short each time would never settle);
       a width or font change re-fits. */
    function fits() { try { return !btnSpan.clientWidth || btnSpan.scrollWidth <= btnSpan.clientWidth + 1; } catch (e) { return true; } }
    function fitSticky(label) {
      var opts = [label], m = /^(.*?)\s+\u2013\s+(.+)$/.exec(label);
      if (m) {
        var c = /^Add (\d+)\b/.exec(m[1]);
        if (c && m[1] !== 'Add ' + c[1]) opts.push('Add ' + c[1] + ' \u2013 ' + m[2]);
        opts.push('Add \u2013 ' + m[2], m[2]);
      }
      for (var i = 0; i < opts.length; i++) {
        setText(btnT, opts[i]);
        if (fits()) return;
      }
    }
    /* The price line never cuts the price: when the struck old price does not fit beside it (a 320 px
       phone, a long pack label), the old price is left out. Measured only when the texts or the
       width change (hiding is an attribute: the page observer never sees it, nothing loops). */
    var lastPrice = null;
    function setPrice(now, was) {
      setText(priceT, now);
      setText(wasT, was);
      nowEl.hidden = !now;
      var key = now + '|' + was + '|' + W.innerWidth;
      if (key === lastPrice) return;
      lastPrice = key;
      wasEl.hidden = !was;
      priceEl.hidden = !now && !was;
      if (was && !priceEl.hidden) {
        var w = priceEl.clientWidth;
        if (w && priceEl.scrollWidth > w + 1) { wasEl.hidden = true; priceEl.hidden = !now; }
      }
    }
    function refitSticky() { srcLabel = null; lastPrice = null; sync(); }
    function show(on) {
      on = !!on && !(btn.disabled && !labelOf(themeBtn));
      if (on === shown) return;
      shown = on;
      if (on) { addClass(bar, 'ow-cb-sticky--on'); bar.setAttribute('aria-hidden', 'false'); }
      else { removeClass(bar, 'ow-cb-sticky--on'); bar.setAttribute('aria-hidden', 'true'); }
      raf(function () { setLift(shown && bar.offsetHeight ? bar.offsetHeight : 0); });
    }
    function sync() {
      if (!themeBtn || !D.contains(themeBtn)) {
        var nb = findButton();
        if (nb && nb !== themeBtn) { themeBtn = nb; watch(); }
      }
      var label = labelOf(themeBtn) || st.label || 'Add to Cart';
      if (label !== srcLabel) { srcLabel = label; fitSticky(label); }
      var disabled = !!(themeBtn && (themeBtn.disabled || themeBtn.getAttribute('aria-disabled') === 'true'));
      btn.disabled = disabled;
      /* A pack label carries its own price ("Add 4 \u2013 \u00a312.60", or the box's marked price): no second price
         beside it \u2014 only the box's own struck price of that pack, when the box shows one. Otherwise the
         variant's price and, when it is on sale, its compare-at price struck through. */
      var withPrice = labelMarked(themeBtn, label) || labelHasPrice(label);
      var p = withPrice ? '' : priceText();
      setPrice(p, withPrice ? packStrike() : (p ? compareText() : ''));
      if (PRODUCT.title) setText(titleT, PRODUCT.title);
    }
    var io = null;
    function watch() {
      if (!W.IntersectionObserver || !themeBtn) return;
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        show(past);
      });
      io.observe(themeBtn);
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var now = Date.now();
      if (now - lastTap < 1200) return; /* one tap = one add */
      lastTap = now;
      if (!themeBtn || !D.contains(themeBtn)) themeBtn = findButton();
      if (!themeBtn || themeBtn.disabled || themeBtn.getAttribute('aria-disabled') === 'true') return;
      /* The theme's own button: the bundle box's capture listener (when a pack is chosen) or
         the theme's product form handles the add \u2014 never this script. */
      themeBtn.click();
    });
    sync();
    watch();
    /* An instant jump (an in-page "#\u2026" link, e.g. a landing page's "N reviews" line) can take the button from below
       the screen to far above it: the observer reports nothing then, so the position is also read on scroll and
       hashchange, once per frame (fix 2026-10-07, landing review round 3). */
    var posQueued = false;
    function recheck() {
      if (posQueued) return;
      posQueued = true;
      raf(function () {
        posQueued = false;
        if (!themeBtn || !D.contains(themeBtn)) return;
        var r = themeBtn.getBoundingClientRect();
        past = r.bottom < 0;
        show(past);
      });
    }
    W.addEventListener('scroll', recheck, { passive: true });
    W.addEventListener('hashchange', recheck);
    onDomFrame(sync);
    /* A currency switch: our own writes are dropped from the page observer, so follow the event too. */
    D.addEventListener('ow:currency', function () { safe('sticky', function () { lastPrice = null; sync(); }); });
    W.addEventListener('pageshow', function (e) { if (e && e.persisted) { lastTap = 0; refitSticky(); } });
    var resizeQueued = false, lastWidth = W.innerWidth;
    W.addEventListener('resize', function () {
      /* Width only: a phone's address bar showing / hiding changes the height on every scroll. */
      if (resizeQueued || W.innerWidth === lastWidth) return;
      resizeQueued = true;
      raf(function () { resizeQueued = false; lastWidth = W.innerWidth; refitSticky(); });
    });
    try {
      if (D.fonts) {
        if (D.fonts.ready && D.fonts.ready.then) D.fonts.ready.then(function () { safe('sticky fit', refitSticky); });
        if (D.fonts.addEventListener) D.fonts.addEventListener('loadingdone', function () { safe('sticky fit', refitSticky); });
      }
    } catch (e) {}
  });

  /* \u2500\u2500 3. Related products: printed by the theme section; hidden while Vitals still shows its own. \u2500\u2500 */
  safe('related', function () {
    if (C.related && vitalsHas(22)) addClass(HTML, 'ow-cb-vrp');
  });

  /* \u2500\u2500 4. Scroll to top \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('scroll top', function () {
    var t = C.scrollTop;
    if (!t) return;
    var b = D.createElement('button');
    b.type = 'button';
    b.className = 'ow-cb-top ow-cb-fixed ow-cb-top--' + (t.pos === 'bottom_left' ? 'bl' : 'br');
    b.setAttribute('aria-label', 'Back to top');
    b.setAttribute('data-ow-noconv', '');
    b.style.setProperty('--ow-top-bg', t.bg || '#111111');
    b.style.setProperty('--ow-top-fg', t.fg || '#ffffff');
    b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 5l-7 7 1.4 1.4L11 8.8V20h2V8.8l4.6 4.6L19 12z" fill="currentColor"/></svg>';
    b.tabIndex = -1;
    D.body.appendChild(b);
    var on = false, queued = false;
    function check() {
      queued = false;
      var y = W.pageYOffset || HTML.scrollTop || 0;
      var want = y > Math.max(400, (W.innerHeight || 600) * 0.8);
      if (want === on) return;
      on = want;
      if (on) { addClass(b, 'ow-cb-top--on'); b.tabIndex = 0; } else { removeClass(b, 'ow-cb-top--on'); b.tabIndex = -1; }
    }
    W.addEventListener('scroll', function () { if (!queued) { queued = true; raf(check); } }, { passive: true });
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var reduce = false;
      try { reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (x) {}
      try { W.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); } catch (x) { W.scrollTo(0, 0); }
    });
    check();
  });

  /* \u2500\u2500 5. Inactive tab message \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('inactive tab', function () {
    var t = C.inactiveTab;
    if (!t || !t.message || vitalsHas(13) || typeof D.hidden === 'undefined') return;
    /* "shown" is what document.title reads back after we set it: the browser collapses spaces
       ("Come  back" reads "Come back"), so comparing with the raw message never matched (fix 2026-10-07). */
    var saved = null, shown = null;
    D.addEventListener('visibilitychange', function () {
      try {
        if (D.hidden) { if (saved === null) { saved = D.title; D.title = String(t.message); shown = D.title; } }
        else if (saved !== null) { if (D.title === shown) D.title = saved; saved = null; shown = null; }
      } catch (e) {}
    });
  });

  /* \u2500\u2500 6. Product label \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */
  safe('label', function () {
    var L = C.label;
    if (!L || !(L.ids && L.ids.length) && !(L.handles && L.handles.length)) return;
    var IDS = {}, HANDLES = {}, i;
    for (i = 0; i < (L.ids || []).length; i++) IDS[String(L.ids[i])] = 1;
    for (i = 0; i < (L.handles || []).length; i++) HANDLES[String(L.handles[i]).toLowerCase()] = 1;
    function wanted(id, handle) { return (id && IDS[String(id)] === 1) || (handle && HANDLES[String(handle).toLowerCase()] === 1); }
    function owLabelFont(size) { return Math.min(size, Math.max(8, Math.round(size * 0.7))); }
    function owLabelPlan(L, hostW, hostH, need) {
      var circle = L.layout === 'circle', strip = L.layout === 'strip';
      var room = strip ? Math.max(0, Math.floor(hostW)) : Math.max(0, Math.floor(hostW) - 8);
      if (circle && hostH > 0) room = Math.min(room, Math.max(0, Math.floor(hostH) - 8));
      function want(fs) { var n = need(fs); return circle ? Math.ceil(Math.sqrt(n * n + fs * fs)) : Math.ceil(n); }
      var floor = owLabelFont(L.size), fs = L.size, w = want(fs);
      while (w > room && fs > floor) { fs--; w = want(fs); }
      var fits = w <= room;
      var line = Math.ceil(fs * 1.25), h = Math.max(L.h, line);
      if (hostH > 0) h = Math.max(line, Math.min(h, Math.floor(hostH) - 8));
      if (strip) return { fs: fs, w: null, h: h, fits: fits };
      w = Math.min(room, Math.max(circle ? Math.max(L.w, L.h) : L.w, w));
      return { fs: fs, w: w, h: circle ? w : h, fits: fits };
    }
    var LABEL_GAP = 8;
    var STRIP = L.layout === 'strip', CIRCLE = L.layout === 'circle';
    /* Every style of the label is written inline with !important (fix 2026-10-07): a theme rule on its host's
       children beats a class rule \u2014 Dawn's ".product__media-item > * { display:block; position:relative }"
       (loaded after our stylesheet) put the label UNDER the picture, over the thumbnails, on every Dawn
       layout. Inline !important wins over any stylesheet rule, !important ones included.
       Layer 2 (review 2026-10-07): Dawn's header group is z-index 3 (the sticky bar, the phone menu drawer and the
       search overlay open INSIDE it) \u2014 at 3 the label, later in the page, painted over all of them on phones and
       wherever the gallery is no stacking context of its own. Dawn's own layers on the picture are 2 or lower and
       come earlier in the page (zoom icon 1, the lightbox button's cover 2), so the label still shows on top of
       the picture and of a card's picture. */
    function imp(el, k, v) { try { el.style.setProperty(k, v, 'important'); } catch (e) {} }
    function make() {
      var el = D.createElement('span');
      el.className = 'ow-cb-label ow-cb-label--' + (STRIP ? 'strip' : CIRCLE ? 'circle' : 'rect');
      el.setAttribute('data-ow-noconv', '');
      el.setAttribute('aria-hidden', 'true');
      var base = [['position', 'absolute'], ['display', 'flex'], ['z-index', '2'], ['margin', '0'], ['float', 'none'],
        ['right', 'auto'], ['bottom', 'auto'], ['box-sizing', 'border-box'], ['padding', '0 6px'], ['align-items', 'center'],
        ['justify-content', 'center'], ['overflow', 'hidden'], ['white-space', 'nowrap'], ['text-overflow', 'ellipsis'],
        ['line-height', '1'], ['pointer-events', 'none'], ['aspect-ratio', 'auto']];
      for (var k = 0; k < base.length; k++) imp(el, base[k][0], base[k][1]);
      imp(el, 'background', L.bg); imp(el, 'color', L.fg); imp(el, 'font-size', L.size + 'px');
      imp(el, 'opacity', String(Math.max(0, Math.min(100, L.o)) / 100));
      imp(el, 'top', L.v + '%');
      /* Until it is measured (fit): the saved size is the smallest, the text decides the rest. */
      imp(el, 'height', 'auto'); imp(el, 'min-height', L.h + 'px'); imp(el, 'max-height', 'none');
      if (STRIP) {
        imp(el, 'left', '0'); imp(el, 'width', '100%'); imp(el, 'min-width', '0'); imp(el, 'max-width', 'none');
        imp(el, 'border-radius', '0'); imp(el, 'transform', 'translateY(-' + L.v + '%)');
      } else {
        var w = CIRCLE ? Math.max(L.w, L.h) : L.w;
        if (CIRCLE) { imp(el, 'width', w + 'px'); imp(el, 'min-width', '0'); imp(el, 'max-width', 'none'); imp(el, 'height', w + 'px'); imp(el, 'min-height', '0'); }
        else { imp(el, 'width', 'max-content'); imp(el, 'min-width', w + 'px'); imp(el, 'max-width', 'calc(100% - ' + LABEL_GAP + 'px)'); }
        imp(el, 'left', L.x + '%');
        imp(el, 'border-radius', CIRCLE ? '50%' : L.r + 'px');
        imp(el, 'transform', 'translate(-' + L.x + '%, -' + L.v + '%)');
      }
      /* The text sits in its own block (a flex container cannot show "\u2026"; centred overflowing text was cut
         at BOTH ends): it shrinks with the label and ends in "\u2026" only when even the smallest size is too wide. */
      var t = D.createElement('span');
      t.className = 'ow-cb-label__t';
      var inner = [['display', 'block'], ['position', 'static'], ['float', 'none'], ['margin', '0'], ['padding', '0'],
        ['flex', '0 1 auto'], ['min-width', '0'], ['max-width', '100%'], ['width', 'auto'], ['height', 'auto'], ['transform', 'none'],
        ['overflow', 'hidden'], ['white-space', 'nowrap'], ['text-overflow', 'ellipsis'], ['line-height', '1.25']];
      for (k = 0; k < inner.length; k++) imp(t, inner[k][0], inner[k][1]);
      textNode(t, L.text);
      el.appendChild(t);
      return el;
    }
    /* Size it on its picture (shared/conversionBooster/labelFit.ts \u2014 the app's preview uses the same rule):
       the saved width / height are the smallest size, it grows to its whole text on one line, never wider
       than the picture minus 8 px; only then the text shrinks (to 70 %, never under 8 px) and is cut. */
    function fit(el) {
      var host = el.parentNode;
      if (!host || !shownEl(el)) return;
      var hw = host.clientWidth, hh = host.clientHeight;
      if (!(hw > 0)) return;
      var need = function (fs) {
        imp(el, 'font-size', fs + 'px'); imp(el, 'width', 'max-content'); imp(el, 'min-width', '0'); imp(el, 'max-width', 'none');
        var n = parseFloat(W.getComputedStyle(el).width);
        return n > 0 ? n : el.scrollWidth;
      };
      var p = owLabelPlan({ layout: L.layout, size: L.size, w: L.w, h: L.h }, hw, hh, need);
      imp(el, 'font-size', p.fs + 'px');
      if (p.w == null) { imp(el, 'width', '100%'); imp(el, 'min-width', '0'); imp(el, 'max-width', 'none'); }
      else { imp(el, 'width', p.w + 'px'); imp(el, 'min-width', p.w + 'px'); imp(el, 'max-width', p.w + 'px'); }
      imp(el, 'height', p.h + 'px'); imp(el, 'min-height', p.h + 'px'); imp(el, 'max-height', p.h + 'px');
    }
    function fitAll() {
      var ls = D.querySelectorAll('.ow-cb-label');
      for (var k = 0; k < ls.length; k++) safe('label: fit', (function (el) { return function () { fit(el); }; })(ls[k]));
    }
    var fitQueued = false;
    function refit() { if (fitQueued) return; fitQueued = true; raf(function () { fitQueued = false; fitAll(); }); }
    /* Re-measured when its picture changes size (a slider laid out late, a rotated phone, a thumbnail shown)
       and when the theme's web font arrives (the text is wider in it). Never a node moved or removed. */
    var RO = null;
    try { if (W.ResizeObserver) RO = new W.ResizeObserver(function () { refit(); }); } catch (e) { RO = null; }
    if (!RO) { try { W.addEventListener('resize', refit); } catch (e) {} }
    try {
      if (D.fonts) {
        if (D.fonts.addEventListener) D.fonts.addEventListener('loadingdone', refit);
        if (D.fonts.ready && D.fonts.ready.then) D.fonts.ready.then(refit, noop);
      }
    } catch (e) {}
    function place(host, productLabel) {
      var el = make();
      if (productLabel) el.setAttribute('data-ow-pl', '');
      host.appendChild(el);
      if (RO) { try { RO.observe(host); } catch (e) {} }
      fit(el);
      return el;
    }
    function host(el) {
      try { if (W.getComputedStyle(el).position === 'static') el.style.position = 'relative'; } catch (e) {}
      return el;
    }
    function ensure(container) {
      if (!container) return;
      for (var k = 0; k < container.children.length; k++) if ((' ' + container.children[k].className + ' ').indexOf(' ow-cb-label ') !== -1) return;
      place(host(container));
    }
    /* The product page: the label goes on the FIRST image the shopper sees, never on the whole
       gallery (fix 2026-10-07). Dawn's desktop "stacked" and "columns" layouts put every image in one
       slider-component, so a % of the gallery drifted down (stacked) or landed on the second image
       (columns). The anchor is the active media item when it is shown (Dawn moves is-active to the
       variant's image, which it also puts first), else the first shown item; slider-component /
       media-gallery only for a gallery without Dawn's media items. Inside the item the label sits on the
       picture's own box (Dawn 12+ .product-media-container, which can be narrower than the item when
       the picture's height is capped), else on the item. When the anchor changes (a thumbnail click in
       the thumbnail layouts), a label is added there and the others are hidden \u2014 never moved or
       removed (no removed nodes: the cart guard re-checks the cart on those). */
    function shownEl(el) { try { return !!el && el.getClientRects().length > 0; } catch (e) { return false; } }
    function pictureOf(item) {
      var c = null;
      for (var k = 0; k < item.children.length; k++) if ((' ' + item.children[k].className + ' ').indexOf(' product-media-container ') !== -1) { c = item.children[k]; break; }
      return c && shownEl(c) ? c : item;
    }
    /* The gallery the shopper SEES (review 2026-10-07): Dawn 8\u201313 with "Desktop media position: Right" prints the
       gallery twice \u2014 a phone copy (hidden from 750 px) before the text and a "-duplicate" copy (hidden under
       750 px) after it \u2014 so the first one in the page was the hidden copy on computers and no label showed. The
       first SHOWN gallery wins (Dawn's slider-component, else media-gallery, else the media wrapper); the first one
       in the page only while none is shown (nothing laid out yet). */
    var GALLERIES = ['slider-component[id^="GalleryViewer"]', 'media-gallery', '.product__media-wrapper'];
    function galleryAnchor() {
      var g = null, k, j, list;
      for (k = 0; k < GALLERIES.length && !g; k++) {
        list = D.querySelectorAll(GALLERIES[k]);
        for (j = 0; j < list.length && !g; j++) if (shownEl(list[j])) g = list[j];
      }
      for (k = 0; k < GALLERIES.length && !g; k++) g = D.querySelector(GALLERIES[k]);
      if (!g) return null;
      var items = g.querySelectorAll('.product__media-item');
      if (!items.length) return { box: g, scope: g };
      var act = g.querySelector('.product__media-item.is-active');
      if (shownEl(act)) return { box: pictureOf(act), scope: g };
      for (k = 0; k < items.length; k++) if (shownEl(items[k])) return { box: pictureOf(items[k]), scope: g };
      return { box: pictureOf(act || items[0]), scope: g };
    }
    var galObs = null, galWatched = null, galQueued = false;
    function schedulePage() {
      if (galQueued) return;
      galQueued = true;
      raf(function () { galQueued = false; safe('label: product page', productPage); });
    }
    function watchGallery(el) {
      /* Thumbnail layouts: a click only moves the is-active class (no node added) \u2014 follow it, in the gallery
         that was chosen (a gallery shown again later is watched again then). */
      if (!el || el === galWatched || !W.MutationObserver) return;
      if (galObs) galObs.disconnect();
      galWatched = el;
      galObs = new MutationObserver(schedulePage);
      galObs.observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
    function productPage() {
      if (!L.product || !PRODUCT || !wanted(PRODUCT.id, PRODUCT.handle)) return;
      var a = galleryAnchor();
      if (!a) return;
      watchGallery(a.scope.closest ? (a.scope.closest('media-gallery') || a.scope) : a.scope);
      /* Every product-page label of the page (data-ow-pl), in whichever gallery copy: one shown, the others hidden. */
      var have = D.querySelectorAll('.ow-cb-label[data-ow-pl]'), mine = null, k;
      for (k = 0; k < have.length; k++) if (!mine && have[k].parentNode === a.box) mine = have[k];
      for (k = 0; k < have.length; k++) {
        /* Shown / hidden with !important too (a theme's "> *" display rule never wins). */
        var want = have[k] === mine ? 'flex' : 'none';
        if (have[k].style.getPropertyValue('display') !== want || have[k].style.getPropertyPriority('display') !== 'important') {
          imp(have[k], 'display', want);
          if (want === 'flex') fit(have[k]);
        }
      }
      if (!mine) place(host(a.box), true);
    }
    /* Dawn's 750 / 990 px steps show and hide whole gallery copies without any change in the page (a window resized,
       a tablet turned): choose the gallery again when the screen crosses one. */
    if (L.product && PRODUCT && wanted(PRODUCT.id, PRODUCT.handle) && W.matchMedia) {
      var STEPS = ['(min-width: 750px)', '(min-width: 990px)'];
      for (var stepI = 0; stepI < STEPS.length; stepI++) {
        try {
          var stepMq = W.matchMedia(STEPS[stepI]);
          if (stepMq.addEventListener) stepMq.addEventListener('change', schedulePage);
          else if (stepMq.addListener) stepMq.addListener(schedulePage);
        } catch (e) {}
      }
    }
    function cardIdentity(card) {
      var a = card.querySelector('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
      var id = a ? (/-(\d+)$/.exec(a.getAttribute('id') || '') || [])[1] : null;
      var link = a || card.querySelector('a[href*="/products/"]');
      var h = link ? (/\/products\/([^\/?#]+)/.exec(link.getAttribute('href') || '') || [])[1] : null;
      try { if (h) h = decodeURIComponent(h); } catch (e) {}
      return { id: id, handle: h };
    }
    function cards() {
      if (!L.cards) return;
      var list = D.querySelectorAll('.card-wrapper');
      for (var k = 0; k < list.length && k < 400; k++) {
        var c = list[k], who = cardIdentity(c);
        if (!wanted(who.id, who.handle)) continue;
        ensure(c.querySelector('.card__inner') || c.querySelector('.card__media'));
      }
    }
    function run() { safe('label: product page', productPage); safe('label: cards', cards); }
    run();
    onDomFrame(run);
  });

  /* \u2500\u2500 7. Store credit line (owner 2026-10-14; doc 19 \u00a711.10 \u2014 storeCreditDisplay.ts CREDIT_LINE_JS) \u2500\u2500 */
  safe('store credit', function () {
    function owCreditPackCount(t, products) {
  t = t || {};
  products = products || {};
  var bp = t.bundleProducts || [], fg = t.freeGifts || [], seen = {}, n = 0, i, p;
  for (i = 0; i < bp.length; i++) {
    p = products[bp[i]];
    if (!p) continue;
    n += 1;
    seen[String(p.variantId)] = true;
  }
  for (i = 0; i < fg.length; i++) {
    p = products[fg[i] && fg[i].key];
    if (!p || seen[String(p.variantId)]) continue;
    n += 1;
    seen[String(p.variantId)] = true;
  }
  return n;
}
function owCreditPriceCents(s) {
  var n = parseFloat(String(s == null ? '' : s).replace(/[^0-9.]/g, ''));
  return isFinite(n) ? Math.round(n * 100) : null;
}
function owCreditAmountCents(position, amounts, paidCents) {
  var paid = Math.floor(Number(paidCents));
  if (!isFinite(paid) || paid <= 0) return 0;
  var raw = amounts ? amounts[position] : 0;
  var set = Math.round(Number(raw == null ? 0 : raw));
  set = isFinite(set) ? Math.max(0, Math.min(5000, set)) : 0;
  var cap = Math.floor((paid * 30) / 100);
  var v = Math.min(set, cap);
  return v >= 50 ? v : 0;
}
function owCreditTiers(data, amounts, arm) {
  if (!data || typeof data !== 'object') return [];
  var list = data.tiers || [];
  if (data.abTest || data.ab) {
    var vv = data.variants && data.variants[arm === 'b' ? 'b' : 'a'];
    list = (vv && vv.tiers) || [];
  }
  var products = data.products || {}, counts = [], max = 0, out = [], i, c, pos, price;
  for (i = 0; i < list.length; i++) {
    c = owCreditPackCount(list[i], products);
    counts.push(c);
    if (c > max) max = c;
  }
  for (i = 0; i < list.length; i++) {
    pos = counts[i] <= 1 ? 'single' : counts[i] === max ? 'largest' : 'middle';
    price = owCreditPriceCents(list[i] && list[i].displayPrice);
    out.push({ id: String(list[i] && list[i].id), idx: i, position: pos, priceCents: price, cents: owCreditAmountCents(pos, amounts, price == null ? 0 : price) });
  }
  return out;
}
function owCreditMoney(cents, currency, explicit) {
  var code = String(currency == null ? 'USD' : currency).toUpperCase(), text;
  var value = Math.round(Number(cents) || 0) / 100;
  try {
    text = new Intl.NumberFormat('en-US', { style: 'currency', currency: /^[A-Z]{3}$/.test(code) ? code : 'USD' }).format(value);
  } catch (e) {
    text = value.toFixed(2) + ' ' + code;
  }
  return explicit && code === 'USD' && text.charAt(0) === '$' ? 'US' + text : text;
}
function owCreditLine(cents, currency, explicit) {
  return cents > 0 ? 'Earn ' + owCreditMoney(cents, currency, explicit) + ' store credit' : '';
}
function owCreditConf(g) {
  var c = g && g.c ? g.c.credit : null, s = g && g.shop ? String(g.shop.currency || '').toUpperCase() : '';
  if (!c || typeof c !== 'object' || !c.a || typeof c.a !== 'object' || typeof c.cur !== 'string') return null;
  var cur = c.cur.toUpperCase();
  return /^[A-Z]{3}$/.test(cur) && cur === s ? { a: c.a, cur: cur } : null;
}
function owCreditUnit(P, M, store, id) {
  var vp = P && P.vp && typeof P.vp === 'object' ? P.vp : null, k = id == null ? '' : String(id);
  var u = vp && k && Object.prototype.hasOwnProperty.call(vp, k) ? Number(vp[k]) : NaN;
  if (!isFinite(u) || u < 0) return null;
  var sc = window.Shopify && window.Shopify.currency, a = sc && sc.active ? String(sc.active).toUpperCase() : '';
  var q = M && typeof M.cur === 'string' ? M.cur.toUpperCase() : '';
  var pc = /^[A-Z]{3}$/.test(q) ? q : /^[A-Z]{3}$/.test(a) ? a : store;
  if (pc === store) return Math.round(u);
  if (a && a !== pc) return null;
  var r = sc ? Number(sc.rate) : NaN;
  return isFinite(r) && r > 0 ? Math.round(u / r) : null;
}
function owCreditSingle(P, M, cr, id) {
  var c = owCreditUnit(P, M, cr.cur, id);
  return c == null ? 0 : owCreditAmountCents('single', cr.a, c);
}
function owCreditVariantSel(P, M, cr, id) {
  var c = owCreditSingle(P, M, cr, id), vp = P && P.vp && typeof P.vp === 'object' ? P.vp : null, k = id == null ? '' : String(id), v;
  if (c > 0) return { cents: c, soft: 0 };
  if (vp) for (v in vp) if (Object.prototype.hasOwnProperty.call(vp, v) && v !== k && owCreditSingle(P, M, cr, v) > 0) return { cents: 0, soft: 3 };
  return { cents: 0, soft: 0 };
}
function owCreditVariant(D, P) {
  var i = D.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') || D.querySelector('product-form form input[name="id"]') || D.querySelector('form[action*="/cart/add"] input[name="id"]');
  var v = i && i.value ? String(i.value) : '';
  return /^\d{1,20}$/.test(v) ? v : P.v;
}
function owCreditJson(D) {
  var el = D.getElementById('kbBundleData'), d = null;
  if (!el) return null;
  try { d = JSON.parse(el.textContent || 'null'); } catch (e) { d = null; }
  return d && typeof d === 'object' ? d : null;
}
function owCreditBoxView(D, b, data, P) {
  if (!b || !data || (P && P.handle && data.handle != null && String(data.handle) !== String(P.handle))) return null;
  var c = ' ' + D.documentElement.className + ' ', arm = 'a', root = null;
  if (data.ab) {
    arm = c.indexOf(' kb-ab-b ') !== -1 ? 'b' : c.indexOf(' kb-ab-a ') !== -1 ? 'a' : window._kbAbVariant === 'b' ? 'b' : 'a';
    root = b.querySelector('.kb-v-' + arm);
  } else root = b.querySelector('.kb-v-only');
  return root ? { arm: arm, root: root } : null;
}
function owCreditRank(p) {
  return p === 'largest' ? 2 : p === 'middle' ? 1 : 0;
}
function owCreditSel(list, root) {
  var sel = root ? root.querySelector('.kb-bar--selected') : null, idx = sel ? parseInt(sel.getAttribute('data-kb-idx'), 10) : -1;
  var t = idx >= 0 && idx < list.length ? list[idx] : null, big = false, other = false, i;
  if (t && t.cents > 0) return { cents: t.cents, soft: 0 };
  for (i = 0; i < list.length; i++) {
    if (i === idx || !(list[i].cents > 0)) continue;
    other = true;
    if (t && owCreditRank(list[i].position) > owCreditRank(t.position)) big = true;
  }
  return { cents: 0, soft: big ? 1 : other ? 2 : 0 };
}
function owCreditSoft(soft) {
  return soft === 1 ? 'Bigger packs earn store credit' : soft === 2 ? 'Other packs earn store credit' : soft === 3 ? 'Other options earn store credit' : '';
}
function owCreditAnchor(D, P) {
  if (P && P.bx) {
    var b = D.getElementById('kbBox');
    if (!b || !b.parentNode) return null;
    var n = b.nextElementSibling, last = b;
    while (n && n.tagName === 'SCRIPT') { last = n; n = n.nextElementSibling; }
    return { parent: b.parentNode, before: n || last.nextSibling, box: b, open: !n };
  }
  var p = D.querySelector('[id^="price-template"]');
  return p && p.parentNode ? { parent: p.parentNode, before: p.nextSibling, box: null, open: false } : null;
}
function owCreditPut(D, n, s) {
  var x = n.firstChild;
  if (x && x.nodeType === 3) {
    if (x.nodeValue !== s) x.nodeValue = s;
  } else if (s) n.appendChild(D.createTextNode(s));
}
function owCreditParts(D, el, coin) {
  var q = function (c) { return el.querySelector('.ow-cb-credit__' + c); };
  var row = q('row'), pill = q('pill'), pre = q('pre'), amt = q('amt'), post = q('post'), mk, ic, t;
  if (row && pill && pre && amt && post) return { row: row, pill: pill, pre: pre, amt: amt, post: post };
  if (el.firstChild) return null;
  mk = function (tag, c, parent) { var n = D.createElement(tag); n.className = 'ow-cb-credit__' + c; parent.appendChild(n); return n; };
  row = mk('div', 'row', el);
  pill = mk('span', 'pill', row);
  ic = mk('span', 'ic', pill);
  ic.setAttribute('aria-hidden', 'true');
  ic.innerHTML = coin;
  t = mk('span', 't', pill);
  pre = mk('span', 'pre', t);
  amt = mk('b', 'amt', t);
  post = mk('span', 'post', t);
  return { row: row, pill: pill, pre: pre, amt: amt, post: post };
}
function owCreditPaint(D, q, el, money, soft) {
  var line = money ? owCreditEarn(money) : owCreditSoft(soft);
  var at = money ? line.indexOf(money) : -1, s = !money && line ? '1' : '0', d = line ? 'block' : 'none';
  owCreditPut(D, q.pre, at >= 0 ? line.slice(0, at) : line);
  owCreditPut(D, q.amt, at >= 0 ? money : '');
  owCreditPut(D, q.post, at >= 0 ? line.slice(at + money.length) : '');
  if (el.getAttribute('data-ow-soft') !== s) el.setAttribute('data-ow-soft', s);
  if (el.style.display !== d) el.style.display = d;
  return money;
}
function owCreditInfo(amount) {
  return 'After your order you get a personal code worth ' + amount + ', straight after checkout. Use it within 30 days with the same email, on an order of ' + amount + ' or more, on patterns bought on their own (not on bundle packs).';
}
function owCreditEarn(m) {
  return m ? 'Earn ' + m + ' store credit' : '';
}
function owCreditInfoAbout(a, n) {
  return 'After your order you get a personal code worth about ' + a + ', straight after checkout. Use it within 30 days with the same email, on an order of about ' + n + ' or more, on patterns bought on their own (not on bundle packs).';
}
function owCreditTell(sh) {
  return sh.ab ? owCreditInfoAbout(sh.m, sh.n) : owCreditInfo(sh.m);
}
function owCreditRate(v) {
  var s = typeof v === 'number' ? String(v) : typeof v === 'string' ? v : '', n;
  if (!/^\d+(\.\d+)?$/.test(s)) return 0;
  n = Number(s);
  return isFinite(n) && n > 0 && n < 1e7 ? n : 0;
}
function owCreditDecode(s) {
  var bad = false, ent = { amp: '&', nbsp: '\u00a0', euro: '\u20ac', pound: '\u00a3', yen: '\u00a5', dollar: '$', cent: '\u00a2' };
  var out = String(s).replace(/&(#[0-9]+|#[xX][0-9a-fA-F]+|[A-Za-z][A-Za-z0-9]*);/g, function (m, b) {
    var cp;
    if (b.charAt(0) === '#') {
      cp = b.charAt(1) === 'x' || b.charAt(1) === 'X' ? parseInt(b.slice(2), 16) : parseInt(b.slice(1), 10);
      if (!(cp > 0 && cp < 0x110000)) { bad = true; return m; }
      if (cp < 0x10000) return String.fromCharCode(cp);
      cp -= 0x10000;
      return String.fromCharCode(0xd800 + (cp >> 10), 0xdc00 + (cp & 0x3ff));
    }
    if (Object.prototype.hasOwnProperty.call(ent, b)) return ent[b];
    bad = true;
    return m;
  });
  return bad ? null : out;
}
function owCreditShape(probe) {
  var sp = function (c) { return c === ' ' || c === '\u00a0' || c === '\u202f'; };
  if (typeof probe !== 'string' || !probe) return null;
  var segs = probe.split(/<[^>]*>/), seg = null, i, dc, run, pre, suf, digits, dec, seps = [], cur = '', ch, g, d;
  for (i = 0; i < segs.length; i++) {
    dc = owCreditDecode(segs[i]);
    if (dc == null) return null;
    if (/^\s*$/.test(dc)) continue;
    if (seg != null || !/\d/.test(dc)) return null;
    seg = dc;
  }
  if (seg == null) return null;
  run = /\d[\d.,' \u00a0\u202f]*\d/.exec(seg);
  if (!run) return null;
  pre = seg.slice(0, run.index).replace(/^\s+/, '');
  suf = seg.slice(run.index + run[0].length).replace(/\s+$/, '');
  if (/\d/.test(pre) || /\d/.test(suf) || (!pre && !suf)) return null;
  digits = run[0].replace(/\D/g, '');
  dec = digits === '123456789' ? 2 : digits === '1234568' ? 0 : -1;
  if (dec === -1) return null;
  for (i = 1; i < run[0].length; i++) { ch = run[0].charAt(i); if (/\d/.test(ch)) { seps.push(cur); cur = ''; } else cur += ch; }
  g = seps[0]; d = dec === 2 ? seps[6] : '';
  if (seps[3] !== g || !(g === '' || g === ',' || g === '.' || g === "'" || sp(g))) return null;
  if (dec === 2 && !(d === '.' || d === ',')) return null;
  if (dec === 2 && d === g) return null;
  for (i = 0; i < seps.length; i++) { if (i === 0 || i === 3 || (dec === 2 && i === 6)) continue; if (seps[i] !== '') return null; }
  return { dec: dec, d: d, g: g, pre: pre, suf: suf };
}
function owCreditFmt(u, f) {
  var a = Math.abs(u), w, fr, b, grp = function (x) { return f.g ? x.replace(/\B(?=(\d{3})+(?!\d))/g, function () { return f.g; }) : x; };
  if (!isFinite(u)) return '';
  if (f.dec === 0) b = grp(String(Math.floor(a / 100 + 0.5)));
  else { w = Math.floor(a / 100); fr = String(a - w * 100); if (fr.length < 2) fr = '0' + fr; b = grp(String(w)) + f.d + fr; }
  return (u < 0 ? '-' : '') + f.pre + b + f.suf;
}
function owCreditRound(cents, rate, g, up) {
  var q = Math.round(cents * rate / g * 1e6) / 1e6;
  return Math.round((up ? Math.ceil(q) : Math.floor(q)) * g * 10) / 10;
}
function owCreditCtx(M, store, cc, B) {
  var sc = window.Shopify && window.Shopify.currency, a = sc && sc.active ? String(sc.active).toUpperCase() : '';
  var q = M && typeof M.cur === 'string' ? M.cur.toUpperCase() : '', c3 = /^[A-Z]{3}$/, p, x, pg, t, tr, tg;
  p = c3.test(a) ? a : c3.test(q) ? q : store;
  x = { s: store, p: p, r: 0, f: null, t: p, tr: 0, tg: 0, tp: null };
  if (p !== store && a === p && !(c3.test(q) && q !== a)) {
    x.r = owCreditRate(sc.rate);
    x.f = x.r > 0 && M ? owCreditShape(cc ? M.mc : M.m) : null;
  }
  try {
    if (B && typeof B.currency === 'function') {
      t = String(B.currency() || '').toUpperCase();
      pg = typeof B.page === 'function' ? B.page() : { currency: store };
      if (c3.test(t) && pg && String(pg.currency || '').toUpperCase() === p) {
        x.t = t;
        if (t !== p && t !== store && typeof B.print === 'function' && typeof B.step === 'function' && typeof B.rate === 'function') {
          tr = Number(B.rate(t));
          tg = Number(B.step(t));
          if (tr > 0 && tg > 0 && /\d/.test(String(B.print(tg * 100, t)))) {
            x.tr = tr;
            x.tg = tg;
            x.tp = function (u) { return String(B.print(u, t)); };
          }
        }
      }
    }
  } catch (e) {}
  return x;
}
function owCreditShow(cents, x) {
  var s = x.s, p = x.p || s, t = x.t || p, g, lo, m;
  if (t === p && p !== s && x.r > 0 && x.f) {
    g = x.f.dec === 0 ? 100 : 1;
    lo = owCreditRound(cents, x.r, g, false);
    if (lo > 0) return { m: owCreditFmt(lo, x.f), n: owCreditFmt(owCreditRound(cents, x.r, g, true), x.f), ab: 1 };
  } else if (t !== p && t !== s && x.tr > 0 && x.tg > 0 && x.tp) {
    lo = owCreditRound(cents, x.tr, x.tg, false);
    if (lo > 0) return { m: x.tp(lo), n: x.tp(owCreditRound(cents, x.tr, x.tg, true)), ab: 1 };
  }
  m = owCreditMoney(cents, s, p !== s || t !== s);
  return { m: m, n: m, ab: 0 };
}
    var CR = owCreditConf(cfg);
    if (!CR || !PRODUCT) return;
    var STORE = CR.cur, P = PRODUCT, MORE_ID = 'ow-cb-credit-more', COIN = "<svg viewBox=\"0 0 20 20\" width=\"18\" height=\"18\" aria-hidden=\"true\" focusable=\"false\"><circle cx=\"10\" cy=\"10\" r=\"9\" fill=\"#f5b83d\"/><circle cx=\"10\" cy=\"10\" r=\"6.4\" fill=\"none\" stroke=\"#c98a12\" stroke-width=\"1.3\"/><path d=\"M10 6.2l1.15 2.35 2.6.38-1.88 1.83.44 2.58L10 12.12l-2.31 1.22.44-2.58-1.88-1.83 2.6-.38z\" fill=\"#fff4d6\"/></svg>", RESERVE = "display:block;box-sizing:border-box;min-height:32px;padding:0";
    var root = null, parts = null, more = null, moreT = null, btn = null;
    var last = null, inserts = 0, jsonEl = null, jsonText = null, jsonLen = -1, json = null, tiersArm = null, tiers = [], kbObs = null, kbWatched = null;
    function onLanding() { return (' ' + HTML.className + ' ').indexOf(' owlp-lp ') !== -1; }
    /* The currency the page's prices are shown in, and how (owner 2026-10-19 - owCreditCtx / owCreditShow): Shopify's local
       currency at Shopify's own rate in the page's money format, the converter's pick at the converter's rate and format, else
       the store currency as before ("US$5.00" while another currency is on the page). */
    function ctxNow() { return owCreditCtx(MONEY, STORE, P.cc === true, OWB); }
    /* The box's data, read again only when its element or text changes (a pack tap changes neither). */
    function boxData() {
      var el = D.getElementById('kbBundleData'), tn = el ? el.firstChild : null, len = tn && tn.nodeType === 3 ? tn.length : -1;
      if (el !== jsonEl || tn !== jsonText || len !== jsonLen) { jsonEl = el; jsonText = tn; jsonLen = len; json = el ? owCreditJson(D) : null; tiersArm = null; }
      return json;
    }
    function tiersOf(data, arm) {
      if (tiersArm !== arm) { tiersArm = arm; tiers = owCreditTiers(data, CR.a, arm); }
      return tiers;
    }
    function compute() {
      if (onLanding()) return null;
      var at = owCreditAnchor(D, P);
      if (!at) return null;
      if (!at.box) { var sv = owCreditVariantSel(P, MONEY, CR, owCreditVariant(D, P)); return { at: at, cents: sv.cents, soft: sv.soft }; }
      if ((at.box.closest && at.box.closest('.owlp-engine')) || at.box.style.display === 'none') return { at: at, cents: 0, soft: 0, off: true };
      var data = boxData(), v = owCreditBoxView(D, at.box, data, P);
      if (!v) return { at: at, cents: 0, soft: 0, off: true };
      var s = owCreditSel(tiersOf(data, v.arm), v.root);
      return { at: at, cents: s.cents, soft: s.soft };
    }
    function setOpen(on) {
      if (!more || !btn) return;
      more.hidden = !on;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    /* Takes the reserve script's block over (its parts adopted, never drawn twice) or fills a new one; the info button and its explanation are the runtime's. */
    function build(el) {
      var q = owCreditParts(D, el, COIN);
      if (!q) return false;
      root = el; parts = q;
      root.setAttribute('data-ow-noconv', '');
      btn = D.createElement('button'); btn.type = 'button'; btn.className = 'ow-cb-credit__i';
      btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', MORE_ID); btn.setAttribute('aria-label', 'What is store credit?');
      var dot = D.createElement('span'); dot.setAttribute('aria-hidden', 'true'); textNode(dot, 'i'); btn.appendChild(dot);
      q.pill.appendChild(btn);
      more = D.createElement('p'); more.className = 'ow-cb-credit__more'; more.id = MORE_ID; more.hidden = true;
      moreT = textNode(more, '');
      root.appendChild(more);
      /* The whole pill opens the explanation (a big target for a thumb); the button is the keyboard's way in. The soft words have none. */
      q.pill.addEventListener('click', function (e) { if (e && e.preventDefault) e.preventDefault(); if (root.getAttribute('data-ow-soft') === '1') return; setOpen(more.hidden); });
      root.addEventListener('keydown', function (e) { if (e && (e.key === 'Escape' || e.key === 'Esc') && !more.hidden) { setOpen(false); try { btn.focus(); } catch (x) {} } });
      root.setAttribute('data-ow-live', '');
      return true;
    }
    function render() {
      var c = compute();
      if (!c) return;
      if (!root || !D.contains(root)) {
        var have = D.querySelector('.ow-cb-credit[data-ow-cr]');
        if (have) {
          if (have.getAttribute('data-ow-live') != null || !build(have)) return;
        } else {
          /* No block yet: one only when there is something to say (a theme that keeps taking it out: 20 times at most). */
          if (c.off || !(c.cents > 0 || c.soft > 0) || inserts >= 20) return;
          inserts++;
          var el = D.createElement('div');
          el.className = 'ow-cb-credit';
          el.setAttribute('data-ow-cr', c.at.box ? 'box' : 'price');
          el.style.cssText = RESERVE;
          if (!build(el)) return;
          c.at.parent.insertBefore(el, c.at.before);
        }
        last = null;
      }
      var cents = c.off ? 0 : c.cents, soft = c.off ? 0 : c.soft, sh = cents > 0 ? owCreditShow(cents, ctxNow()) : null;
      var key = cents + '|' + soft + '|' + (sh ? sh.m + '|' + sh.n + '|' + sh.ab : '');
      if (key === last) return;
      last = key;
      /* The selected pack's words, the soft words (it earns nothing while another pack does), or nothing: the block folds away. */
      var money = owCreditPaint(D, parts, root, sh ? sh.m : '', soft);
      if (money) setText(moreT, owCreditTell(sh));
      else setOpen(false);
      root.setAttribute('data-ow-credit', String(cents));
    }
    /* A pack tap moves kb-bar--selected to another row inside the box: the words follow in the same frame. */
    function watchBox() {
      var b = D.getElementById('kbBox');
      if (!b || b === kbWatched || !W.MutationObserver) return;
      if (kbObs) kbObs.disconnect();
      kbWatched = b;
      kbObs = new MutationObserver(function () { safe('store credit', render); });
      kbObs.observe(b, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
    }
    /* The shopper's own pick of an option (a radio or a select: a trusted event) on a page without a box closes the
       explanation NOW, inside the tap's input window: a theme that re-renders the price long after the tap (Dawn 15
       asks the store for the new price block first) then changes the words only (the row keeps its height). */
    function picked(e) {
      var t = e && e.target;
      if (!e || e.isTrusted !== true || !more || more.hidden || !root || root.getAttribute('data-ow-cr') !== 'price' || !t || root.contains(t)) return;
      if (t.tagName === 'SELECT' || (t.tagName === 'INPUT' && String(t.type).toLowerCase() === 'radio')) setOpen(false);
    }
    render();
    watchBox();
    /* A late box, a theme re-render (a variant change re-prints the price), a removed line: looked at again at once. */
    onDom(function () { watchBox(); render(); });
    D.addEventListener('ow:currency', function () { safe('store credit', render); });
    D.addEventListener('change', function (e) { safe('store credit', function () { picked(e); }); raf(function () { safe('store credit', render); }); }, true);
  });
})();
